// Code generated by balancegen from data/locale/<tag>/*.toml and
// data/contracts/languages.toml. DO NOT EDIT.
// Regenerate with scripts/gen-data.sh.
//
// One language part of the SOURCE language: some of its tables
// (i18n.md §1.1, R3123). gen/strings.ts imports every part statically
// and joins them, so every page has the English tables with no load.
// The parts keep each build chunk under Vite's limit (deployment.md
// §2.2).
//
// The module imports gen/strings.ts for its types alone. A runtime
// import would make the two chunks import each other.

import type * as S from './strings';

const pluralRules = new Intl.PluralRules('en');

/**
 * Picks the plural variant for a count. The category comes from the
 * platform's CLDR rule for the language of this file, so the file has
 * no rule of its own. `other` is the fallback: it is the one category every language
 * has, and a language that needs no `few` simply has none written.
 */
function plural(n: number, forms: Record<string, string | undefined> & { other: string }): string {
  return forms[pluralRules.select(n)] ?? forms.other;
}

const overlay_en: S.Overlay = {
  admin_advance: 'advance time',
  admin_advance_step_title: (p: { step: string | number }) => `+${p.step} of world time — the schedule moves, nothing runs`,
  admin_advance_title: 'jump the world clock forward; the schedule moves, nothing runs',
  admin_autopilot: 'TOGGLE AUTOPILOT',
  admin_caches: 'TOGGLE CACHES',
  admin_caches_title: 'show every cache of the season on the map: seeded caches, ruins, pirate caches, player caches and event caches; a taken cache shows spent',
  admin_drain_end: 'CARD',
  admin_drain_end_title: 'end the drain of the settlement: the season summary card opens',
  admin_fog: 'TOGGLE FOG',
  admin_grant: '+100K ALL',
  admin_map_clock: (p: { scale: string | number }) => `map clock · ${p.scale}x`,
  admin_map_clock_title: 'movement, combat, torpedoes, detection, anchor cycles',
  admin_maxbase: 'MAX BASE/TECH',
  admin_maxfleet: '+1 FLEET',
  admin_maxfleet_title: 'one hull of every class, past capacity',
  admin_reload_wardroom: 'RELOAD WARDROOM',
  admin_reload_wardroom_title: 'your next join loads the carried wardroom again and replaces the captains you hold now',
  admin_reseed: 'RESEED',
  admin_reseed_armed: 'RESEED?',
  admin_reseed_title: 'new seed: a different map, the season restarts, captains and Honour keep',
  admin_restart: 'RESTART FRESH',
  admin_restart_armed: 'RESTART FRESH?',
  admin_roll: 'ROLL SEASON',
  admin_roll_armed: 'ROLL SEASON?',
  admin_row_economy: 'economy',
  admin_row_empire: 'empire',
  admin_row_progress: 'progress',
  admin_row_seaquake: 'seaquake',
  admin_row_server: 'server',
  admin_row_view: 'view',
  admin_rush: 'RUSH QUEUE',
  admin_saverestart: 'SAVE &amp; RESTART',
  admin_scale_title: (p: { n: string | number }) => `${p.n}x`,
  admin_stage1: 'STAGE 1',
  admin_stage2: 'STAGE 2',
  admin_stage3: 'STAGE 3',
  admin_sub: 'server tuning — dev builds only',
  admin_title: 'DEV ADMIN',
  admin_veil: 'TOGGLE VEIL',
  admin_veil_title: 'lift the survey hatch for this client: every cell, depth band, current and point of interest shows; the survey of your faction does not change',
  admin_world_clock: (p: { scale: string | number }) => `world clock · ${p.scale}x`,
  admin_world_clock_title: 'economy, queue, research, gathering, events, season',
  advance_steps: ['1h', '6h', '1d'],
  attr_short: ['GUN', 'HLM', 'QUI', 'ENG', 'CMD', 'PRO'],
  auc_add_offer: 'ADD OFFER',
  auc_browse: 'BROWSE',
  auction_head: (p: { count: string | number; credits: string | number }) => `Auction · ${p.count} listings · ¤${p.credits}`,
  auction_lot: 'lot',
  auction_lot_name: (p: { qty: string | number }) => `${p.qty} isotopes`,
  auction_lots_head: 'Isotope lots',
  auction_no_lots: 'no lots on offer',
  auction_no_prints: 'no prints on offer',
  auction_nothing_sellable: 'nothing sellable in the library',
  auction_print_sub: (p: { types: string | number; inventor: string | number; seller: string | number }) => `${p.types} · ${p.inventor}'s pattern · ${p.seller}`,
  auction_prints_head: 'Prints',
  auction_sell_iso_head: (p: { held: string | number }) => `Sell isotopes · ☢ ${p.held} held`,
  auction_sell_print_head: 'Sell a print',
  auction_total_placeholder: '¤ total',
  auction_unit: (p: { price: string | number }) => `¤${p.price} a unit`,
  auction_units_placeholder: 'units',
  audio_empty: 'nothing to play in this playlist',
  audio_foot: 'the volume lives in ☸ OPTIONS · \'m\' opens and closes this card',
  audio_next_title: 'next track',
  audio_pause_title: 'pause',
  audio_play_title: 'play',
  audio_prev_title: 'previous track',
  audio_shuffle_title: 'shuffle',
  audio_stop_title: 'stop',
  audio_title: 'MUSIC',
  audio_tracks: (p: { count: number }) => plural(p.count, {
    one: `${p.count} track · press a title to play it`,
    other: `${p.count} tracks · press a title to play it`,
  }),
  bar_dev_title: 'dev admin panel',
  bar_home_title: 'centre on your hold',
  bar_inbox: 'INBOX',
  bar_inbox_title: 'messages',
  bar_music: 'MUSIC',
  bar_opts: 'OPTIONS',
  bar_opts_title: 'display and sound settings',
  bar_pct: (p: { pct: string | number }) => `${p.pct}%`,
  bar_rank_label: (p: { title: string | number; rank: string | number }) => `Honour rank ${p.title} · place ${p.rank} in the season table`,
  bar_rank_label_new: (p: { title: string | number }) => `Honour rank ${p.title}`,
  bar_standing: 'STANDING ORDERS',
  bar_standing_title: 'the autopilot keeps this empire while you play the weekend · press to open OPTIONS → PLAY, where the switch stands',
  bartip_clock_title: 'World clock',
  bartip_cores_depth: (p: { depth: string | number; pct: string | number }) => `depth ${p.depth} ${p.pct}%`,
  bartip_cores_does: (p: { work: string | number }) => `one core completes up to ${p.work} of research work on the active node. The rest of the core is lost`,
  bartip_cores_have: (p: { have: string | number }) => `${p.have} in store`,
  bartip_cores_how: (p: { chances: string | number }) => `a captain on an expedition dive can bring back one core on surfacing: ${p.chances}`,
  bartip_cores_how_plain: 'a captain on an expedition dive can bring back one core on surfacing',
  bartip_cores_title: 'Data Cores',
  bartip_full: 'FULL',
  bartip_season_resets: (p: { season: string | number; left: string | number }) => `Season ${p.season} resets in ${p.left}`,
  bartip_stored: (p: { have: string | number; cap: string | number }) => `${p.have} of ${p.cap} stored`,
  bartip_uncapped: (p: { have: string | number }) => `${p.have} · no storage limit`,
  bartip_world_real: (p: { world: string | number; real: string | number; scale: string | number }) => `${p.world} of world time · about ${p.real} of real time at ${p.scale}x`,
  beam_fleet: (p: { fleet: string | number; owner: string | number }) => `${p.fleet} · ${p.owner}`,
  beam_taking: (p: { from: string | number; pos: string | number }) => `taking ${p.from} · ${p.pos}`,
  beams_empty: 'no beam is taking ground you can see',
  beams_head: 'Beams taking ground',
  bj_bust: 'bust',
  bj_dealer_shows: (p: { card: string | number }) => `the dealer shows ${p.card}`,
  bj_dealer_soft_17: 'the dealer hits a soft 17',
  bj_double: 'DOUBLE',
  bj_hit: 'HIT',
  bj_insurance_ask: 'insurance?',
  bj_insurance_cost: (p: { amount: string | number; pays: string | number }) => `insurance costs ${p.amount} and pays ${p.pays} to one`,
  bj_insurance_pays: (p: { pays: string | number }) => `insurance pays ${p.pays} to one`,
  bj_natural: 'a natural',
  bj_natural_pays: (p: { num: string | number; den: string | number }) => `a natural pays ${p.num} to ${p.den}`,
  bj_no: 'NO',
  bj_shoe: (p: { decks: string | number }) => `the shoe holds ${p.decks} decks`,
  bj_shoe_spanish: (p: { decks: string | number }) => `the shoe holds ${p.decks} decks with no 10: a jack, a queen and a king count ten`,
  bj_split: 'SPLIT',
  bj_stand: 'STAND',
  bj_yes: 'YES',
  bj_you_have: (p: { value: string | number }) => `you have ${p.value}`,
  break_armed: 'BREAK UP?',
  brief_alloy_rate: 'alloy',
  brief_base_cap: 'level cap',
  brief_base_tubes: 'hold tubes',
  brief_biomass_rate: 'biomass',
  brief_build_slots: 'build slots',
  brief_captain_slots: 'captains',
  brief_capture_chance: 'capture',
  brief_capture_range: 'capture',
  brief_combat_cap: 'combat',
  brief_copy_slots: 'prints',
  brief_deployable_cap: 'deployables',
  brief_dive_risk: 'dive risk',
  brief_hospital_hours: 'rest',
  brief_hours: (p: { n: string | number }) => `${p.n} h`,
  brief_isotope_lots: 'isotope lots',
  brief_lane_light_cap: 'Fanals',
  brief_master_slots: 'masters',
  brief_mission_cap: 'fleets at sea',
  brief_opens: (p: { what: string | number }) => `opens ${p.what}`,
  brief_opens_base_tubes: 'hold fires',
  brief_opens_build_slot: (p: { n: string | number }) => `build slot ${p.n}`,
  brief_opens_module_slot: (p: { n: string | number }) => `${p.n} modules`,
  brief_opens_oracle_share: 'Oracle share',
  brief_opens_point_defence: 'point defense',
  brief_opens_recv_fleet: 'pooled rings',
  brief_opens_recv_installation: 'faction rings',
  brief_opens_recv_warship: 'squad hulls',
  brief_opens_share_fleet: 'fleet share',
  brief_opens_shield_types: 'shield types',
  brief_opens_tech_tier: (p: { n: string | number }) => `tech tier ${p.n}`,
  brief_opens_weapon_types: 'weapon types',
  brief_palisade_cap: 'Palisades',
  brief_per_hour: (p: { n: string | number }) => `${p.n}/h`,
  brief_print_listings: 'print lots',
  brief_prison_cells: 'cells',
  brief_px: (p: { n: string | number }) => `${p.n} px`,
  brief_queue_speed: 'queue speed',
  brief_research_speed: 'research',
  brief_sea_mine_cap: 'sea mines',
  brief_sea_object_rack: 'rack',
  brief_ship_round_storage: 'ship rounds',
  brief_ship_speed: 'yard speed',
  brief_sonar_range: 'sonar',
  brief_storage_cap: 'store',
  brief_support_cap: 'support',
  brief_torpedo_storage: 'rack',
  brief_training_speed: 'training',
  brief_volatiles_rate: 'volatiles',
  brig_empty: 'the cells are empty',
  brig_head: (p: { n: string | number; cells: string | number }) => `The Brig ${p.n}/${p.cells}`,
  brig_no_prison: 'no Brig',
  brig_prisoner: (p: { owner: string | number; ransom: string | number }) => `of ${p.owner} · ransom ¤${p.ransom} when they pay`,
  brig_prisoner_held: (p: { owner: string | number; held: string | number; ransom: string | number }) => `of ${p.owner} · held ${p.held} · ransom ¤${p.ransom} when they pay`,
  btn_aboard: 'ABOARD',
  btn_assign_named: (p: { name: string | number }) => `ASSIGN ${p.name}`,
  btn_break: 'BREAK',
  btn_bring_ashore: 'BRING ASHORE',
  btn_build: 'BUILD',
  btn_build_batch: (p: { n: string | number }) => `BUILD ×${p.n}`,
  btn_buy: 'BUY',
  btn_captain: 'CAPTAIN',
  btn_commit: 'PLEDGE',
  btn_commit_no: 'CANCEL',
  btn_core_cancel: 'CANCEL',
  btn_decrypt: 'DECRYPT',
  btn_defend: 'DEFEND',
  btn_delist: 'DELIST',
  btn_deploy: 'DEPLOY',
  btn_done: 'DONE',
  btn_install: 'INSTALL',
  btn_list: 'LIST',
  btn_load: 'LOADOUT',
  btn_load_save: 'STOW',
  btn_locked: 'LOCKED',
  btn_max: 'MAX',
  btn_order: 'ORDER',
  btn_pass: (p: { price: string | number }) => `PASS ¤${p.price}`,
  btn_pay: (p: { ransom: string | number }) => `PAY ¤${p.ransom}`,
  btn_pick_target: 'PICK TARGET…',
  btn_plan_centre: 'CENTRE',
  btn_plan_engage: 'ENGAGE',
  btn_plan_flank: 'FLANK',
  btn_plan_front: 'FRONT',
  btn_plan_hold: 'HOLD',
  btn_plan_rear: 'REAR',
  btn_recruit: 'RECRUIT',
  btn_redraft: 'REDRAFT',
  btn_release: 'RELEASE',
  btn_release_price: (p: { price: string | number }) => `RELEASE ¤${p.price}`,
  btn_rename_cancel: 'CANCEL',
  btn_rename_save: 'SAVE',
  btn_rename_title: 'Give this hull a new name',
  btn_repair: 'REPAIR',
  btn_report_name: '⚑',
  btn_report_name_title: 'Report this name',
  btn_scrap: 'SCRAP',
  btn_sell: 'SELL',
  btn_send_dive: 'SEND',
  btn_send_named: (p: { name: string | number }) => `SEND ${p.name}`,
  btn_show: 'SHOW',
  btn_spend_core: 'SPEND THE CORE',
  btn_start_dive: 'START',
  btn_stow: 'LOADOUT',
  bucket_combat: 'combat',
  bucket_head_combat: (p: { w: string | number; cap: string | number }) => `Combat · ${p.w}/${p.cap}`,
  bucket_head_support: (p: { w: string | number; cap: string | number }) => `Support · ${p.w}/${p.cap}`,
  bucket_support: 'support',
  cap_back: 'BACK',
  cap_back_title: 'back to the page above',
  cap_close: 'CLOSE',
  cap_close_title: 'close the OPTIONS menu',
  cap_eff_command: (p: { pct: string | number }) => `readiness floor +${p.pct} points`,
  cap_eff_engineering: (p: { pct: string | number }) => `+${p.pct}% shield regeneration`,
  cap_eff_gunnery: (p: { pct: string | number }) => `+${p.pct}% fleet damage`,
  cap_eff_helm: (p: { pct: string | number }) => `+${p.pct}% fleet speed`,
  cap_eff_prospecting: (p: { pct: string | number; cut: string | number }) => `+${p.pct}% dive yield · −${p.cut}% dive injury`,
  cap_eff_silent: (p: { pct: string | number }) => `−${p.pct}% fleet noise`,
  cap_inbox: 'INBOX',
  cap_inbox_title: 'messages',
  cap_menu: 'MENU',
  cap_menu_title: 'the OPTIONS menu',
  cap_nobody: 'nobody ashore to board — see CAPTAIN · WARDROOM',
  cap_practice_command: 'grows with time in foreign water',
  cap_practice_engineering: 'grows with shield won back by regeneration',
  cap_practice_gunnery: 'grows with damage dealt at sea',
  cap_practice_helm: 'grows with time under way',
  cap_practice_prospecting: 'grows with the depth of each dive',
  cap_practice_silent: 'grows with time unheard in foreign water',
  cap_support_none: 'support fleets sail without a captain',
  capcard_talent_mark: '★',
  capcard_why_cadet: 'Cadet: no practice and no training until recruited.',
  capcard_why_held: 'Held: no practice and no training until free.',
  capinfo_backstory: 'Backstory',
  capinfo_decline: 'decline · loses one attribute point each season',
  capinfo_now: 'Now',
  capinfo_peak: (p: { n: number }) => plural(p.n, {
    one: `peak · decline in ${p.n} season`,
    other: `peak · decline in ${p.n} seasons`,
  }),
  capinfo_practice: 'Practice',
  capinfo_practice_decline: (p: { pct: string | number }) => `${p.pct}% of the rate in decline`,
  capinfo_retire: 'Decline roll',
  capinfo_retire_val: (p: { pct: string | number }) => `${p.pct}% after the next season`,
  capinfo_rise: (p: { n: number }) => plural(p.n, {
    one: `rise · peak in ${p.n} season`,
    other: `rise · peak in ${p.n} seasons`,
  }),
  capinfo_sub: 'captain · ★ [[talent|talent]]',
  capinfo_sub_cadet: 'cadet · ★ [[talent|talent]]',
  caprow_aboard: (p: { name: string | number }) => `aboard ${p.name}`,
  caprow_age: (p: { age: string | number }) => `age ${p.age}`,
  caprow_age_career: (p: { age: string | number; career: string | number }) => `age ${p.age} · ${p.career}`,
  caprow_captured: (p: { who: string | number; ransom: string | number }) => `held by ${p.who} · ransom ¤${p.ransom}`,
  caprow_cell_talent: (p: { attr: string | number; v: string | number }) => `${p.attr} ${p.v} · talent`,
  caprow_cell_title: (p: { attr: string | number; v: string | number }) => `${p.attr} ${p.v}`,
  caprow_codes_label: (p: { names: string | number }) => `Attribute names: ${p.names}`,
  caprow_diving: (p: { dive: string | number; left: string | number }) => `${p.dive} · surfaces in ${p.left}`,
  caprow_free: 'free to board or dive',
  caprow_legend: 'A line under a figure marks a [[talent]]: it trains faster.',
  caprow_more_title: (p: { name: string | number }) => `More for ${p.name}`,
  caprow_outfitting: (p: { dive: string | number }) => `${p.dive} · waits in the build queue`,
  caprow_phase_age: (p: { age: string | number; phase: string | number }) => `age ${p.age} · ${p.phase}`,
  caprow_practice: (p: { attr: string | number; pct: string | number; n: string | number }) => `${p.attr}: ${p.pct}% to the next practice point · +${p.n} this season`,
  caprow_recovering: (p: { left: string | number }) => `fit again in ${p.left}`,
  caprow_st_ashore: 'ASHORE',
  caprow_st_at_sea: 'AT SEA',
  caprow_st_cadet: 'CADET',
  caprow_st_captured: 'CAPTURED',
  caprow_st_diving: 'DIVING',
  caprow_st_docked: 'DOCKED',
  caprow_st_outfitting: 'OUTFITTING',
  caprow_st_recovering: 'RECOVERING',
  caprow_st_training: 'TRAINING',
  caprow_training: (p: { attr: string | number; left: string | number }) => `${p.attr} · ${p.left}`,
  caprow_training_queued: (p: { attr: string | number }) => `${p.attr} · queued`,
  capsum_command: (p: { pct: string | number }) => `+${p.pct} points of readiness floor in foreign water per point`,
  capsum_engineering: (p: { pct: string | number }) => `+${p.pct}% shield regeneration per point`,
  capsum_gunnery: (p: { pct: string | number }) => `+${p.pct}% fleet damage per point`,
  capsum_helm: (p: { pct: string | number }) => `+${p.pct}% fleet speed per point`,
  capsum_prospecting: (p: { pct: string | number; cut: string | number }) => `+${p.pct}% dive isotope yield and −${p.cut}% dive injury risk per point`,
  capsum_silent: (p: { pct: string | number; max: string | number }) => `−${p.pct}% fleet noise per point, never more than −${p.max}%`,
  captain_ashore: 'ashore',
  captain_ashore_hint: 'ashore — can board a fleet in the dock',
  captain_commanding: (p: { id: string | number }) => `fleet ${p.id}`,
  captain_expedition: 'at sea on an expedition',
  captain_fleet_title: 'Select this fleet and show it on the map',
  captain_in_pens: (p: { name: string | number }) => `${p.name} · in the pens`,
  captain_outfitting: (p: { dive: string | number }) => `outfitting for the ${p.dive}`,
  captain_prisoner: (p: { who: string | number; ransom: string | number }) => `PRISONER of ${p.who} — ransom ¤${p.ransom}`,
  captain_recovering: (p: { left: string | number }) => `recovering ${p.left}`,
  captrain_at_cap: 'at the training cap',
  captrain_dots: (p: { n: string | number; cap: string | number }) => `practice points this season: ${p.n} of ${p.cap}`,
  captrain_full: 'FULL',
  captrain_max: 'MAX',
  captrain_off_busy: (p: { attr: string | number }) => `already training ${p.attr}: one point at a time`,
  captrain_off_decline: 'no training in decline',
  captrain_off_recovering: (p: { left: string | number }) => `recovering: fit again in ${p.left}`,
  captrain_pct: (p: { pct: string | number }) => `${p.pct}%`,
  captrain_pick_chip: (p: { short: string | number; v: string | number; next: string | number }) => `${p.short} ${p.v}→${p.next}`,
  captrain_pick_close: 'close the pick',
  captrain_pick_head: 'train one point · pick',
  captrain_pick_max: (p: { short: string | number }) => `${p.short} MAX`,
  captrain_pick_none: '—',
  captrain_pick_open: 'open',
  captrain_pick_press: 'TRAIN ▸',
  captrain_pick_title: 'pick the attribute that trains one point',
  captrain_press_title: (p: { attr: string | number }) => `Train ${p.attr}: one point`,
  captrain_queued: (p: { attr: string | number }) => `training ${p.attr} · Queued`,
  captrain_row: (p: { short: string | number }) => `TRAIN ${p.short}`,
  captrain_season_full: (p: { cap: string | number }) => `season cap of ${p.cap} reached`,
  captrain_training: (p: { attr: string | number; left: string | number }) => `training ${p.attr} · ${p.left}`,
  captrain_value: (p: { attr: string | number; v: string | number; cap: string | number }) => `${p.attr}: ${p.v} / ${p.cap}`,
  capture_from: (p: { who: string | number; pos: string | number; when: string | number }) => `from ${p.who} · ${p.pos} · ${p.when}`,
  capture_log_empty: 'no cells have changed hands yet',
  capture_log_head: 'Capture log',
  capture_took: (p: { faction: string | number }) => `${p.faction} took water`,
  capture_took_fleet: (p: { fleet: string | number; owner: string | number }) => `${p.fleet} · ${p.owner} took water`,
  casino_buy_in: (p: { min: string | number; max: string | number }) => `buy in ${p.min} to ${p.max}`,
  casino_card_machine: 'no seat · a pull settles at once',
  casino_card_quiet: 'no open table',
  casino_card_tables: (p: { tables: string | number; seated: string | number }) => `${p.tables} open · ${p.seated} seated`,
  casino_chips: (p: { amount: string | number }) => `chips ${p.amount}`,
  casino_close_title: 'close the casino',
  casino_club_even: (p: { time: string | number }) => `the house holds no net in this club window yet: the next turn of the light is at ${p.time}`,
  casino_club_gain: (p: { time: string | number; pct: string | number; room: string | number; amount: string | number; each: string | number }) => `the turn of the light at ${p.time} pays ${p.pct}% of the house net to the ${p.room}: ${p.amount} so far, ${p.each} each`,
  casino_club_loss: (p: { amount: string | number; time: string | number; room: string | number }) => `this club window carries a loss of ${p.amount}: the turn of the light at ${p.time} pays the ${p.room} nothing`,
  casino_club_of: (p: { faction: string | number; members: number }) => plural(p.members, {
    one: `the club of the ${p.faction} · ${p.members} commander`,
    other: `the club of the ${p.faction} · ${p.members} commanders`,
  }),
  casino_club_row_even: (p: { room: string | number }) => `no share for the ${p.room} yet`,
  casino_club_row_gain: (p: { pct: string | number; room: string | number }) => `${p.pct}% of it goes to the ${p.room} at the turn of the light`,
  casino_club_row_loss: (p: { room: string | number }) => `the club window carries a loss: no share for the ${p.room} yet`,
  casino_delta_down: (p: { amount: string | number }) => `−${p.amount}`,
  casino_delta_even: '±0',
  casino_delta_up: (p: { amount: string | number }) => `+${p.amount}`,
  casino_dock_title: 'stand the casino in the dock column',
  casino_game_blackjack: 'BLACKJACK',
  casino_game_holdem: 'HOLD\'EM',
  casino_game_roulette: 'ROULETTE',
  casino_game_slots: 'SLOT MACHINE',
  casino_hand_settled: 'the hand is settled',
  casino_head: 'The Casino',
  casino_help_k_bet: 'BET',
  casino_help_k_blinds: 'BLINDS',
  casino_help_k_buy_in: 'BUY-IN',
  casino_help_k_dealer: 'DEALER',
  casino_help_k_house: 'HOUSE',
  casino_help_k_insure: 'INSURANCE',
  casino_help_k_keys: 'KEYS',
  casino_help_k_natural: 'NATURAL',
  casino_help_k_payback: 'PAYBACK',
  casino_help_k_pull: 'PULL',
  casino_help_k_rake: 'RAKE',
  casino_help_k_rebet: 'REBET',
  casino_help_k_shoe: 'SHOE',
  casino_help_k_take: 'TAKE BACK',
  casino_help_k_top_up: 'TOP UP',
  casino_help_k_two: 'TWO TAPS',
  casino_help_key: (p: { key: string | number; name: string | number }) => `${p.key} ${p.name}`,
  casino_house_blackjack: (p: { decks: string | number; pct: string | number }) => `${p.decks} decks · the house keeps ${p.pct}%`,
  casino_house_holdem: (p: { pct: string | number; cap: string | number }) => `six seats · the house keeps ${p.pct}% of a pot, at most ${p.cap}`,
  casino_house_of: 'no faction holds a cell, so no club keeps this casino and the house keeps its whole share',
  casino_house_roulette: (p: { pct: string | number }) => `two zeros · the house keeps ${p.pct}%`,
  casino_house_slots: (p: { pct: string | number }) => `three reels · the house keeps ${p.pct}%`,
  casino_join: 'JOIN',
  casino_leave_machine: 'LEAVE THE MACHINE',
  casino_leave_table: 'LEAVE TABLE',
  casino_leave_table_armed: 'LEAVE TABLE?',
  casino_lobby_rules: 'the casino plays for credits alone, never for real money; each game states the share the house keeps',
  casino_min_bet: (p: { amount: string | number }) => `min bet ${p.amount}`,
  casino_next_spin: (p: { sec: string | number }) => `next spin in ${p.sec} s`,
  casino_no_bet: 'you had no bet on this hand',
  casino_no_buy_in: 'you cannot pay the buy-in',
  casino_no_table: 'no table is open',
  casino_open: 'OPEN',
  casino_open_tables: 'open tables',
  casino_pane_away: 'The casino stands wide over the map. DOCK in its head puts it back in this column.',
  casino_pane_idle: 'Pick a game at the left. Its table stands here.',
  casino_place_bet: 'PLACE BET',
  casino_pot: (p: { amount: string | number }) => `pot ${p.amount}`,
  casino_price_bet: (p: { min: string | number }) => `${p.min} a bet`,
  casino_price_hand: (p: { min: string | number }) => `${p.min} a hand`,
  casino_price_pull: (p: { min: string | number }) => `${p.min} a pull`,
  casino_queue_fill_in: (p: { sec: string | number }) => `the house fills the seats in ${p.sec}s`,
  casino_queue_filled: (p: { filled: string | number; seats: string | number }) => `${p.filled} of ${p.seats} seats`,
  casino_queue_leave: 'LEAVE QUEUE',
  casino_queue_leave_armed: 'LEAVE QUEUE?',
  casino_queue_wait: 'you wait for a seat',
  casino_queue_waited: (p: { sec: string | number }) => `waited ${p.sec}s`,
  casino_queued: 'IN QUEUE',
  casino_quick_join: 'QUICK JOIN',
  casino_room_bezants: 'Bezant Room',
  casino_room_chevronels: 'Chevron Room',
  casino_room_frond: 'Frond Room',
  casino_room_gears: 'Gear Room',
  casino_room_other: (p: { faction: string | number }) => `${p.faction} Room`,
  casino_room_title: (p: { room: string | number }) => `the ${p.room}`,
  casino_room_waves: 'Wave Room',
  casino_roster_label: (p: { parts: string | number }) => `the share of the cells of each faction: ${p.parts}`,
  casino_roster_part: (p: { faction: string | number; pct: string | number }) => `${p.faction} ${p.pct}%`,
  casino_seat_folded: 'folded',
  casino_seat_n: (p: { n: string | number }) => `seat ${p.n}`,
  casino_shut: 'the casino of this world is shut',
  casino_shut_why: 'an operator shut it. It opens again later.',
  casino_stake_label: 'stake',
  casino_stake_short: 'you hold too few credits for this stake',
  casino_stakes_back: 'every stake came back',
  casino_stakes_shut: 'a stake over the credits you hold is shut',
  casino_table_gone: 'the table is gone',
  casino_table_row: (p: { game: string | number; tier: string | number; seated: string | number; seats: string | number }) => `${p.game} · ${p.tier} · ${p.seated} of ${p.seats} seats`,
  casino_tier_pill: (p: { min: string | number }) => `min ${p.min}`,
  casino_turn_left: (p: { sec: string | number }) => `${p.sec}s left`,
  casino_undock_title: 'open the casino wide over the map',
  casino_visit_net: 'net this visit',
  casino_wheel_runs: 'the wheel runs now',
  casino_with_key: (p: { name: string | number; key: string | number }) => `${p.name} (${p.key})`,
  casino_word_down: 'DOWN',
  casino_word_even: 'EVEN',
  casino_word_lost: 'LOST',
  casino_word_push: 'PUSH',
  casino_word_up: 'UP',
  casino_word_won: 'WON',
  casino_you_hold: (p: { amount: string | number }) => `you hold ${p.amount} credits`,
  casino_you_sit: (p: { id: string | number }) => `you sit at table ${p.id}`,
  casino_your_turn: 'your turn',
  centre_map_title: 'centre the map here',
  channels: ['WORLD', 'FACTION', 'SQUAD', 'CLAN'],
  chat_big_title: 'make the chat box larger',
  chat_close_title: 'close the chat',
  chat_dock: 'DOCK',
  chat_dock_title: 'dock the chat at the foot of the dock column',
  chat_empty: 'nothing on this channel yet',
  chat_grip_title: 'drag: the chat line, the pane or the whole column',
  chat_head: 'CHAT',
  chat_meta_down: 'clan chat needs the meta server',
  chat_min_title: 'minimize the chat box',
  chat_missed: (p: { n: number }) => plural(p.n, {
    one: `${p.n} message missed`,
    other: `${p.n} messages missed`,
  }),
  chat_no_clan: 'join a clan to talk here',
  chat_placeholder: 'say something…',
  chat_quick_title: 'open the quick wheel',
  chat_reconnecting: 'reconnecting to clan chat …',
  chat_report: '▤ REPORT',
  chat_send: 'SEND',
  chat_show: '⌖ SHOW',
  chat_small_title: 'make the chat box smaller',
  chat_undock: 'UNDOCK',
  chat_undock_title: 'float the chat box at the bottom left of the map',
  chatline_read: (p: { channel: string | number }) => `all read · ${p.channel} is open`,
  chatline_title: 'open the chat',
  chatline_unread: (p: { where: string | number }) => `unread in ${p.where}`,
  chatline_wait: 'new lines wait while the siege warning stands',
  clan_at_sea: 'at sea',
  clan_comms: 'signal station',
  clan_head: (p: { name: string | number; tag: string | number; squad: string | number }) => `${p.name} [${p.tag}] · squad ${p.squad}`,
  clan_hub_note: 'CLANS ARE MANAGED ON THE HUB PAGE. A CHANGE APPLIES AT THE NEXT SEASON.',
  clan_member_comms: (p: { level: string | number }) => ` · signal station ${p.level}`,
  clan_no_bonuses: 'no bonuses yet — someone must build a Signal Station',
  clan_none_head: 'No clan',
  clan_none_note: (p: { members: string | number; squad_size: string | number; squads: number }) => plural(p.squads, {
    one: `A clan is up to ${p.members} commanders in ${p.squads} squad. Its Signal Station level pools the squad's fleet rings and more.`,
    other: `A clan is up to ${p.members} commanders in ${p.squads} squads of ${p.squad_size}. Its Signal Station level pools the squad's fleet rings and more.`,
  }),
  clan_online: 'online',
  clan_reserve: ' · RESERVE',
  clan_roster_head: (p: { n: string | number; max: string | number }) => `Roster ${p.n}/${p.max}`,
  clan_squad: (p: { n: string | number }) => `squad ${p.n}`,
  clock_rule: (p: { day: string | number }) => `The world runs on its own clock, not on yours. One world day takes ${p.day} of real time. The siege window of a strategic object opens at a set hour of this clock.`,
  close_title: 'close',
  com_archive_empty: 'No commission paid you this season.',
  com_archive_hide: 'HIDE',
  com_archive_show: (p: { n: string | number }) => `SHOW ${p.n}`,
  com_assign: 'ASSIGN',
  com_assign_title: (p: { name: string | number }) => `give this offer to ${p.name}. The fleet gets no order.`,
  com_board_none: 'No open offers.',
  com_board_refill: (p: { left: string | number }) => `The board refills in ${p.left}.`,
  com_card_kind_open: 'COMMISSION · ON THE BOARD',
  com_card_kind_pending: 'COMMISSION · PENDING',
  com_card_kind_taken: 'COMMISSION · TAKEN',
  com_chip_open: 'OPEN',
  com_chip_pending: 'PENDING',
  com_chip_taken: 'TAKEN',
  com_count_resets: (p: { left: string | number }) => `Your count resets in ${p.left}.`,
  com_day_full: (p: { n: string | number }) => `You took ${p.n} commissions this world day. The count starts again at the next world day.`,
  com_f_band: 'depth band',
  com_f_fleet: 'fleet',
  com_f_left: 'time left',
  com_f_pays: 'pays',
  com_fit_away: (p: { px: string | number }) => `${p.px} px from the mark`,
  com_fit_count: (p: { n: string | number; total: string | number }) => `${p.n} of ${p.total}`,
  com_fit_head: 'FLEETS THAT FIT',
  com_fleet_gone: 'a fleet that is gone',
  com_head_archive: (p: { n: string | number }) => `ARCHIVE · ${p.n}`,
  com_head_open: (p: { n: string | number }) => `THE BOARD · ${p.n}`,
  com_head_pending: (p: { n: string | number }) => `PENDING · ${p.n}`,
  com_head_taken: (p: { n: string | number }) => `YOUR COMMISSIONS · ${p.n}`,
  com_hint: 'OPEN shows the commission with the fleets that fit it. ASSIGN gives the offer to one fleet and gives no order: you sail the fleet.',
  com_hold_full: (p: { n: string | number }) => `You hold ${p.n} commissions. Finish one to take another.`,
  com_info_title: 'open the commission card',
  com_kind_cache: 'Recover a cache',
  com_kind_den: 'Sink a pirate den',
  com_kind_other: 'A commission',
  com_kind_sound: 'Sound a trench',
  com_kind_survey: 'Survey a region',
  com_left: (p: { left: string | number }) => `${p.left} left`,
  com_more_unfit: (p: { n: number }) => plural(p.n, {
    one: `${p.n} more fleet does not fit.`,
    other: `${p.n} more fleets do not fit.`,
  }),
  com_no_fleet: 'No own fleet is at sea. Put a hull to sea, and it can take the offer.',
  com_note: 'ASSIGN gives the offer to one fleet, one fleet for each press. The fleet gets no order: you sail it to the mark.',
  com_note_taken: (p: { name: string | number }) => `Sail ${p.name} to the mark before the time runs out. The offer fails when the fleet sinks.`,
  com_open: 'OPEN',
  com_open_title: 'open the commission and the fleets that fit it',
  com_paid: 'PAID',
  com_paid_line: (p: { fleet: string | number; day: string | number }) => `${p.fleet} · paid on day ${p.day}`,
  com_paid_title: 'this commission is done and paid',
  com_pay_practice: (p: { n: string | number }) => `captain practice × ${p.n}`,
  com_pay_round_any: 'rounds',
  com_pay_rounds: (p: { n: string | number; name: string | number }) => `${p.n} × ${p.name}`,
  com_pay_ship: (p: { name: string | number }) => `one ${p.name}`,
  com_pay_ship_any: 'hull',
  com_pending: 'PENDING',
  com_pending_line: (p: { name: string | number }) => `The ${p.name} waits for room in the Dock. A higher Dock level, a lost hull or a cancelled hull job frees room.`,
  com_pending_short: 'pending, waits for room in the Dock',
  com_pending_wait: (p: { name: string | number }) => `The task is done, and the pay is pending: the ${p.name} waits for room in the Dock. A higher Dock level, a lost hull or a cancelled hull job frees room, and the hull then comes to the pens.`,
  com_show: 'SHOW ON MAP',
  com_taken: 'TAKEN',
  com_task_cache: 'Recover the cache at the mark.',
  com_task_den: 'Sink every hull of the pirate group of the den at the mark, while the fleet is at sea.',
  com_task_sound: 'Take a hull rated for the abyss into the trench cell of the mark.',
  com_task_survey: 'Take a fleet to the mark. The task is done when the survey of the faction holds the cell.',
  com_today: (p: { n: string | number; max: string | number }) => `${p.n}/${p.max} today`,
  com_today_full: (p: { n: string | number; max: string | number; left: string | number }) => `${p.n}/${p.max} today · resets in ${p.left}`,
  com_today_title: (p: { max: string | number }) => `the commissions you took this world day, of ${p.max}`,
  com_unfit_busy: 'works a commission',
  com_unfit_captain: 'no captain aboard',
  com_unfit_gun: 'mounts no gun',
  com_unfit_rating: (p: { band: string | number }) => `rated ${p.band}`,
  commit_card_ask: (p: { fleet: string | number; place: string | number }) => `${p.fleet} sails to ${p.place} and pledges when it arrives`,
  core_card_ask: 'Spend one Data Core on the active research?',
  deploy_ask: (p: { fleet: string | number }) => `${p.fleet} leaves the pens and sails from the hold`,
  deploy_ask_damaged: (p: { pct: string | number }) => `the hull is at ${p.pct}% — repair it first, or it sails damaged`,
  deploy_ask_no_captain: (p: { fleet: string | number }) => `${p.fleet} needs a captain aboard before it can sail`,
  deploy_ask_repairing: (p: { fleet: string | number }) => `${p.fleet} is under repair and cannot sail until the repair is done`,
  deploy_status_damaged: 'DAMAGED',
  deploy_status_repairing: 'UNDER REPAIR',
  deposit_names: ['alloy', 'biomass', 'volatiles', 'isotopes'],
  depot_empty: 'No kinds of sea object yet: the hello of the world brings their table.',
  depot_head_deployables: (p: { n: string | number; cap: string | number }) => `Deployables · on the map ${p.n}/${p.cap}`,
  depot_head_mines: (p: { n: string | number; cap: string | number }) => `Sea mines · on the map ${p.n}/${p.cap}`,
  depot_head_rack: (p: { w: string | number; cap: string | number }) => `Depot rack · ${p.w}/${p.cap}`,
  depot_held_title: 'the items of this kind in the stock of the Depot',
  depot_limit_lane_lights: (p: { l: string | number; lcap: string | number }) => `Fanals ${p.l}/${p.lcap}`,
  depot_limit_palisades: (p: { p: string | number; pcap: string | number }) => `Palisades ${p.p}/${p.pcap}`,
  depot_line_deployable: (p: { n: string | number }) => `deployable · cargo ${p.n}`,
  depot_line_mine: (p: { n: string | number }) => `sea mine · cargo ${p.n}`,
  depot_none: 'no Depot',
  depot_queued_title: 'the items of this kind in the build queue',
  depot_show_title: 'show the next one on the map',
  dev_branch: (p: { branch: string | number }) => ` on ${p.branch}`,
  dev_restart: 'RESTART',
  dev_title: (p: { build: string | number; branch: string | number; head: string | number }) => `running ${p.build}${p.branch} · HEAD is ${p.head} · restart saves the world and comes back on the new build`,
  eff_alloy_rate: 'alloy an hour',
  eff_base_cap: 'building level cap',
  eff_base_tubes: 'tubes at the hold',
  eff_biomass_rate: 'biomass an hour',
  eff_build_slots: 'build slots',
  eff_captain_slots: 'captain slots',
  eff_capture_chance: 'capture chance',
  eff_capture_range: 'capture range in px',
  eff_change: (p: { n: string | number }) => `(${p.n})`,
  eff_combat_cap: 'combat weight',
  eff_copy_slots: 'print slots',
  eff_deployable_cap: 'deployables on the map',
  eff_dive_risk: 'dive injury risk',
  eff_hospital_hours: 'hours a captain rests',
  eff_isotope_lots: 'isotope lots on the board',
  eff_lane_light_cap: 'Fanals on the map',
  eff_master_slots: 'master slots',
  eff_mission_cap: 'fleets at sea',
  eff_mul: (p: { n: string | number }) => `${p.n}x`,
  eff_palisade_cap: 'Palisades on the map',
  eff_pct: (p: { n: string | number }) => `${p.n}%`,
  eff_print_listings: 'print lots on the board',
  eff_prison_cells: 'cells for prisoners',
  eff_queue_speed: 'queue speed',
  eff_research_speed: 'research speed',
  eff_sea_mine_cap: 'sea mines on the map',
  eff_sea_object_rack: 'sea objects the rack holds',
  eff_ship_round_storage: 'ship rounds the hold stocks',
  eff_ship_speed: 'build and repair speed',
  eff_sonar_range: 'listening range in px',
  eff_step: (p: { now: string | number; next: string | number }) => `${p.now} → ${p.next}`,
  eff_storage_cap: 'cap for each mined resource',
  eff_support_cap: 'support weight',
  eff_torpedo_storage: 'rounds a rack holds',
  eff_training_speed: 'training speed',
  eff_volatiles_rate: 'volatiles an hour',
  empire_waiting: 'waiting for the first empire frame…',
  exp_cap_line: (p: { risk: string | number; isotopes: string | number }) => `${p.risk} · ~${p.isotopes} isotopes`,
  exp_cap_practice: (p: { attr: string | number; fig: string | number }) => `${p.attr} ${p.fig}`,
  exp_captains: 'Captain',
  exp_depth: (p: { depth: string | number }) => `DEPTH ${p.depth}`,
  exp_dive_control: (p: { level: string | number }) => `Dive Control ${p.level}`,
  exp_in_queue: 'in the build queue',
  exp_left: (p: { left: string | number }) => `${p.left} left`,
  exp_no_control: 'no Dive Control',
  exp_nobody: 'no captain ashore can dive',
  exp_outfitting: 'outfitting',
  exp_risk: (p: { injury: string | number }) => `${p.injury}% injury`,
  exp_risk_none: 'no injury',
  exp_sheet_kind: (p: { depth: string | number; time: string | number; clock: string | number }) => `DEPTH ${p.depth} · ${p.time} · BACK ${p.clock}`,
  exp_sheet_note: 'The captain leaves the roster until the dive surfaces. Prospecting cuts the risk and raises the yield.',
  exp_slots: (p: { n: string | number; cap: string | number }) => `${p.n} of ${p.cap} mission slots`,
  exp_start: 'Start a dive',
  exp_sum_by_captain: 'by captain',
  exp_sum_core: 'core',
  exp_sum_core_what: 'a Data Core',
  exp_sum_iso_fig: (p: { n: string | number }) => `~${p.n}`,
  exp_sum_isotopes: 'isotopes',
  exp_sum_none: 'none',
  exp_sum_pct: (p: { pct: string | number }) => `${p.pct}%`,
  exp_sum_range: (p: { lo: string | number; hi: string | number }) => `${p.lo}–${p.hi}%`,
  exp_sum_risk: 'risk',
  exp_sum_yield: 'yield',
  exp_surfaces: (p: { clock: string | number }) => `surfaces ${p.clock}`,
  exp_underway: 'Underway',
  exp_underway_none: 'no dive under way',
  exp_yield: (p: { isotopes: string | number; core: string | number }) => `~${p.isotopes} isotopes · ${p.core}% core`,
  expedition_and_tech: (p: { tech: string | number }) => ` and ${p.tech}`,
  expedition_core_gain: (p: { sooner: string | number }) => `lands ${p.sooner} sooner`,
  expedition_core_none: 'nothing is being decrypted',
  expedition_core_warn: (p: { wasted: string | number; worth: string | number }) => `most of the core is lost on this node: ${p.wasted} of ${p.worth}. A bigger node uses all of it`,
  expedition_core_waste: (p: { wasted: string | number }) => `${p.wasted} of the core is lost — a bigger node wastes nothing`,
  expedition_needs_rad: (p: { level: string | number }) => `needs Dive Control ${p.level}`,
  expedition_no_captain: 'no idle captain',
  expedition_outfitting: 'your only idle captain is already outfitting',
  expedition_running: (p: { depth: string | number; left: string | number }) => `depth ${p.depth} · surfaces in ${p.left}`,
  fatal_protocol_hint: 'reload to pick up the current build',
  fatal_protocol_reload_in: (p: { sec: string | number }) => `reloading in ${p.sec}s`,
  fatal_protocol_title: 'CLIENT / SERVER VERSION MISMATCH',
  fatal_reload: 'RELOAD',
  fatal_start_over: 'START OVER',
  fatal_ticket_hint: 'the world could not seat this account — start over as a new player, or ask the server to reset its seats',
  fatal_ticket_title: 'COULD NOT JOIN THIS WORLD',
  fit_family_marks: ['WP', 'SH', 'PR', 'DP', 'SN'],
  fit_grade_fine: '+',
  fit_grade_flawed: '−',
  fit_grade_perfect: '+++',
  fit_grade_superb: '++',
  fit_module: (p: { family: string | number; tier: string | number; grade: string | number }) => `${p.family}${p.tier}${p.grade}`,
  fit_shield_marks: ['AS', 'BV', 'FS'],
  fit_weapon_marks: ['RS', 'CH', 'VL'],
  fl_assign_captain: 'ASSIGN CAPTAIN',
  fl_cargo: (p: { fig: string | number }) => `cargo ${p.fig}`,
  fl_dock_row_title: (p: { name: string | number }) => `select ${p.name}: its card and DEPLOY`,
  fl_docked: 'in the pens',
  fl_group_title: (p: { n: string | number }) => `control group ${p.n}`,
  fl_more_title: (p: { name: string | number }) => `the orders of ${p.name}`,
  fl_quick_repair_title: (p: { cost: string | number; time: string | number }) => `Quick repair · ${p.cost} · ${p.time}`,
  fl_repair_title: (p: { time: string | number }) => `repair to a whole hull · ${p.time}`,
  fl_rounds: (p: { fig: string | number }) => `rounds ${p.fig}`,
  fl_row_title: (p: { name: string | number }) => `select ${p.name} and centre the map`,
  fl_start_mission: 'START MISSION',
  fl_tubes: (p: { fig: string | number }) => `tubes ${p.fig}`,
  fleets_dive: 'Expedition',
  fleets_empty: 'nothing at sea',
  fleets_head: (p: { n: string | number; cap: string | number }) => `Fleets ${p.n}/${p.cap}`,
  fleets_head_combat: (p: { n: string | number }) => `Combat · ${p.n}`,
  fleets_head_support: (p: { n: string | number }) => `Support · ${p.n}`,
  fleets_pledged: 'Pledged',
  fleets_pledged_at: (p: { place: string | number; window: string | number }) => `at ${p.place} · ${p.window}`,
  grade_fine: 'Fine',
  grade_flawed: 'Flawed',
  grade_perfect: 'Perfect',
  grade_standard: 'Standard',
  grade_superb: 'Superb',
  grip_title: 'drag to resize the sheet',
  groups_label: 'control groups',
  head_build: (p: { build: string | number }) => `build ${p.build} on the dev lane`,
  head_commits: (p: { n: number }) => plural(p.n, {
    one: `${p.n} NEW COMMIT`,
    other: `${p.n} NEW COMMITS`,
  }),
  head_dev: 'DEV',
  head_hold: 'GO TO THE HOLD',
  head_inbox: 'INBOX',
  head_opts: 'OPTIONS',
  hint_aim: 'Click to fire',
  hint_aim_base: 'Click to fire the torpedo of your hold',
  hint_aim_base_touch: 'Tap to place the torpedo of your hold · tap the same spot to fire',
  hint_aim_touch: 'Tap to place the shot · tap the same spot to fire',
  hint_deploy: 'Click water to start the mission',
  hint_deploy_touch: 'Tap water to start the mission',
  hint_escort: 'Click a friendly fleet to escort',
  hint_escort_touch: 'Tap a friendly fleet to escort',
  hint_gather: 'Click a deposit to cut it',
  hint_gather_touch: 'Tap a deposit to cut it',
  hint_gather_vent: 'Click a deposit or a vent to cut it',
  hint_gather_vent_touch: 'Tap a deposit or a vent to cut it',
  hint_hunt: 'Click a contact to attack that contact alone, or water to advance there',
  hint_hunt_touch: 'Tap a contact to attack that contact alone, or water to advance there',
  hint_move: 'Click where to sail — the fleet keeps course past any contact',
  hint_move_touch: 'Tap where to sail — the fleet keeps course past any contact',
  hint_patrol: 'Click the far end of the patrol lane',
  hint_patrol_touch: 'Tap the far end of the patrol lane',
  hint_search: 'Click the cell to search for a cache and for wreck cargo',
  hint_search_touch: 'Tap the cell to search for a cache and for wreck cargo',
  how_age: (p: { min: string | number; max: string | number; years: string | number }) => `a cadet joins at ${p.min} to ${p.max}; a captain ages ${p.years} years a season`,
  how_attr: (p: { rate: string | number; measure: string | number }) => `${p.rate}; ${p.measure}`,
  how_auction_slots: (p: { lots: string | number; prints: string | number }) => `${p.lots} isotope lot per Dive Control level, ${p.prints} print listing per Ship Design level`,
  how_brig: 'one cell per Brig level',
  how_cap: (p: { cap: string | number }) => `an attribute stops at ${p.cap}; it is then mastered and trains no further`,
  how_capture: 'happens when an enemy sinks within reach of your fleets',
  how_career: (p: { peak: string | number; decline: string | number }) => `rise to ${p.peak}, peak to ${p.decline}, then decline; an older cadet starts with more points and has a shorter career`,
  how_count: (p: { n: number }) => plural(p.n, {
    one: `${p.n} fact`,
    other: `${p.n} facts`,
  }),
  how_decline: 'no training; each season takes one attribute point, most likely the highest',
  how_draft_path: 'a Ship Design office drafts a master; a master prints; a print builds',
  how_escrow: 'a lot leaves your store when it lists and comes back whole when you delist',
  how_fleet_path: 'BUILD · SHIPYARD lays down a hull; it waits in the pens until it deploys',
  how_fleet_slots: 'a hull at sea, a dive and a pledged fleet each hold a mission slot',
  how_go: (p: { where: string | number }) => `GO TO ${p.where}`,
  how_head: 'HOW IT WORKS',
  how_in_decline: (p: { pct: string | number }) => `practice counts at ${p.pct}% of the rate`,
  how_k_age: 'Age',
  how_k_brig: 'Brig',
  how_k_cap: 'Cap',
  how_k_capture: 'Capture',
  how_k_career: 'Career',
  how_k_decline: 'Decline',
  how_k_escrow: 'Escrow',
  how_k_in_decline: 'In decline',
  how_k_keystone: 'Keystone',
  how_k_lot: 'Lot size',
  how_k_path: 'Path',
  how_k_peak: 'Peak',
  how_k_practice: 'Practice',
  how_k_print_sale: 'Print sale',
  how_k_retire: 'Retire',
  how_k_roll: 'Roll',
  how_k_season_cap: 'Season cap',
  how_k_sells: 'What sells',
  how_k_shelf: 'Intel shelf',
  how_k_shipyard: 'Shipyard',
  how_k_slots: 'Slots',
  how_k_smoothing: 'Smoothing',
  how_k_squad: 'Squad scans',
  how_k_survey: 'Survey',
  how_k_talent: 'Talent ★',
  how_k_training: 'Training',
  how_keystone: 'one a season; the one held or queued shuts the others',
  how_lot: (p: { min: string | number; max: string | number }) => `${p.min} to ${p.max} units`,
  how_peak: (p: { factor: string | number }) => `a point takes ${p.factor}x as long to train`,
  how_practice: 'a captain aboard a warship grows each attribute by use at sea; the row of each attribute below names its measure',
  how_print_sale: 'a print sells while it is unspent, uninstalled and its hulls are out of the pens',
  how_retire: (p: { base: string | number; per: string | number }) => `each season in decline rolls ${p.base}% to retire or die, +${p.per}% for each later season`,
  how_roll: (p: { low: string | number; high: string | number }) => `each module rolls ${p.low}-${p.high}; a low roll is the most likely, and nothing improves the odds`,
  how_season_cap: (p: { cap: string | number; growth: string | number }) => `${p.cap} practice points per attribute per season; each point costs ${p.growth}x the one before; an Academy point does not count; the season roll resets the count, and the share of the next point carries into the new season`,
  how_sells: 'prints and isotope lots; ships and captains stay off the block',
  how_shelf: (p: { hours: string | number }) => `a scout's SCAN files every contact here for ${p.hours} game-hours`,
  how_shipyard: 'every hull needs one; a class can ask for a higher level',
  how_smoothing: (p: { n: string | number }) => `each graph line is the mean of the last ${p.n} surveys`,
  how_squad: (p: { level: string | number }) => `squadmates' scans appear at Signal Station ${p.level}`,
  how_survey: (p: { min: string | number }) => `every ${p.min} game-minutes`,
  how_talent: (p: { mul: string | number }) => `a talent trains ${p.mul}x as fast, at the Academy and at sea`,
  how_training: (p: { hours: string | number }) => `one point at a time in the build queue; the next point takes its value × ${p.hours} h of work, and each Academy level makes the work faster`,
  info_anchored: 'anchored',
  info_anchored_noise: 'anchored noise',
  info_anchored_range: 'anchored range',
  info_and_takes: 'and takes',
  info_beacon_beam: (p: { n: string | number }) => `beams sov out to ${p.n} hex rings`,
  info_btn_building_title: 'what this does',
  info_btn_captain_title: 'what this captain is worth',
  info_btn_module_title: 'what this module family does',
  info_btn_seaobject_title: 'what this sea object does',
  info_btn_ship_title: 'what this hull is',
  info_btn_tech_title: 'what this unlocks',
  info_btn_torpedo_title: 'what this round does',
  info_bucket_of: (p: { used: string | number; cap: string | number }) => `${p.used} / ${p.cap}`,
  info_bucket_use: (p: { bucket: string | number }) => `${p.bucket} weight`,
  info_capped_base: (p: { level: string | number }) => `Command Centre ${p.level}`,
  info_costs: 'costs',
  info_damage: 'damage',
  info_ff_hits_own: 'the splash hits your own fleets too',
  info_ff_spares_own: 'the splash spares your own fleets',
  info_friendly_fire: 'friendly fire',
  info_from: 'from',
  info_grade_odds: (p: { low: string | number; high: string | number; pct: string | number; onein: string | number }) => `×${p.low}–${p.high} · ${p.pct}% · 1 in ${p.onein}`,
  info_hold: 'hold',
  info_in_the_queue: 'in the queue',
  info_list_time: 'list time',
  info_magazine: 'magazine',
  info_magazine_val: (p: { n: string | number }) => `${p.n} out of the hull's hold`,
  info_module_build_share: (p: { share: string | number }) => `adds ${p.share}% of the hull cost`,
  info_module_draft: 'draft charge',
  info_module_gate: (p: { code: string | number; tech: string | number }) => `${p.code} ${p.tech}`,
  info_module_isotopes: (p: { n: string | number }) => `${p.n} isotopes`,
  info_module_sub: '[[module_family]] · tiers I to III',
  info_module_tier: (p: { tier: string | number }) => `tier ${p.tier}`,
  info_module_worth: (p: { pct: string | number }) => `${p.pct}% before the roll`,
  info_needs: 'needs',
  info_next_level_costs: (p: { level: string | number }) => `level ${p.level} costs`,
  info_noise_mul_val: (p: { mul: string | number }) => `${p.mul}x`,
  info_none: 'none',
  info_opens_at: (p: { level: string | number }) => `level ${p.level}`,
  info_opens_buildings: 'installations',
  info_opens_hulls: 'hulls',
  info_opens_modules: 'modules',
  info_opens_rounds: 'rounds',
  info_per_hull: (p: { n: string | number }) => `${p.n} per hull`,
  info_px: (p: { n: string | number }) => `${p.n} px`,
  info_queued_more: (p: { n: string | number }) => `${p.n} more`,
  info_rack_cap: 'the banks hold',
  info_rate_val: (p: { rate: string | number }) => `${p.rate}x`,
  info_reach: 'range',
  info_repair_val: (p: { range: string | number; pct: string | number; every: string | number }) => `the nearest friendly hull within ${p.range} px, ${p.pct}% of its max hull every ${p.every}`,
  info_repairs: 'repairs',
  info_research_lab_level: (p: { level: string | number }) => `Research Lab ${p.level}`,
  info_role: 'role',
  info_round_costs: 'one round costs',
  info_rounds_held: 'rounds held',
  info_ship_rack: 'ship rounds stocked',
  info_ship_sub: (p: { bucket: string | number; weight: string | number }) => `${p.bucket} [[hull]] · weight ${p.weight}`,
  info_shipyard_level: (p: { level: string | number }) => `Shipyard ${p.level}`,
  info_shot: 'shot',
  info_so_cargo: 'cargo',
  info_so_costs: 'one item costs',
  info_so_depot: (p: { level: string | number }) => `Depot ${p.level}`,
  info_so_hears: 'hears a hull',
  info_so_hears_val: (p: { n: string | number }) => `${p.n} px × its noise`,
  info_so_held: 'in the Depot',
  info_so_kind: (p: { family: string | number; level: string | number }) => `${p.family} · Depot ${p.level}`,
  info_so_length: 'length',
  info_so_listens: 'listens',
  info_so_rack: 'the Depot rack',
  info_so_radius: 'radius',
  info_so_trigger: 'trigger',
  info_source_level: (p: { name: string | number; level: string | number }) => `${p.name} ${p.level}`,
  info_speed: 'speed',
  info_speed_val: (p: { n: string | number }) => `${p.n} px/min`,
  info_splash: 'splash',
  info_stows: 'stows',
  info_stows_val: (p: { n: string | number; round: string | number }) => `${p.n} x ${p.round}, for allied hulls; it fires none`,
  info_strong_vs: 'strong against',
  info_tech_sub: (p: { code: string | number; tier: string | number }) => `${p.code} · tier ${p.tier}`,
  info_tender_aura: (p: { range: string | number; pct: string | number }) => `friendly hulls within ${p.range} px regain ${p.pct}% of max shield a combat second`,
  info_tender_restock: (p: { every: string | number }) => `hands 1 stowed round to an allied hull every ${p.every}`,
  info_weak_vs: 'weak against',
  info_your_rate: 'your rate',
  install_armed: 'INSTALL?',
  intel_centre_title: 'centre the map where it was pinged',
  intel_empty: 'the shelf is empty',
  intel_head: 'Scanned contacts',
  intel_line: (p: { pos: string | number; age: string | number; types: string | number; scanner: string | number }) => `${p.pos} · ${p.age} ago · ${p.types} · ${p.scanner}'s ping`,
  invention_empty: 'no Ship Design office',
  invention_family_taken: 'on the draft',
  invention_fit_bonus: (p: { low: string | number; high: string | number }) => `${p.low}% to ${p.high}%`,
  invention_fit_build: 'builds for',
  invention_fit_draft: 'the draft costs',
  invention_fit_head: 'This fit',
  invention_fit_odds: (p: { pct: string | number; onein: string | number }) => `${p.pct}% · 1 in ${p.onein} for each module`,
  invention_fit_time: 'the draft takes',
  invention_fit_top: (p: { grade: string | number }) => `a ${p.grade} roll`,
  invention_head: 'Draft a design',
  invention_hull: 'hull',
  invention_needs_sd: (p: { level: string | number }) => `needs Ship Design ${p.level}`,
  invention_shield: 'shield',
  invention_slots: (p: { used: string | number; slots: string | number }) => `module slots ${p.used}/${p.slots}`,
  invention_submit: 'INVENT DESIGN',
  invention_unarmed: (p: { hull: string | number }) => `the ${p.hull} mounts no gun, so it takes no weapon system`,
  invention_weapon: 'weapon',
  keys_fold_count: (p: { n: string | number }) => `${p.n} keys`,
  keys_foot: 'every key is a shortcut for an on-screen control — nothing needs a keyboard',
  keys_title: 'KEYBOARD',
  lib_in_use: 'USED',
  lib_more_title: (p: { name: string | number }) => `sell, redraft or scrap ${p.name}`,
  lib_spent: 'SPENT',
  line_block: 'BLOCK',
  line_blocked: 'Every chat hides the lines of that account now. SETTINGS on the hub page lifts the block.',
  line_more: '⋯',
  line_more_title: 'Report or block this line',
  line_report: '⚑ REPORT',
  load_held: (p: { n: string | number }) => `held ${p.n}`,
  load_kind: (p: { cls: string | number; now: string | number }) => `${p.cls} · now ${p.now}`,
  load_less: (p: { name: string | number }) => `one ${p.name} less`,
  load_max: (p: { name: string | number }) => `as many ${p.name} as fit`,
  load_more: (p: { name: string | number }) => `one ${p.name} more`,
  load_note_auto: 'AUTO loads the best round first and fills the free room from the hold.',
  load_note_short: 'The hold has fewer rounds than this mix. The hull sails with what the hold has.',
  load_title: (p: { hull: string | number }) => `LOADOUT · ${p.hull}`,
  map_min_title: 'minimize the chart',
  mission_attacking: 'Attacking',
  mission_withdrawing: 'Withdrawing',
  module_effects: ['adds damage', 'adds shield points and shield regeneration', 'adds speed', 'cuts noise', 'adds sonar range'],
  module_graded: (p: { module: string | number; grade: string | number }) => `${p.module} ${p.grade}`,
  module_roll: (p: { pct: string | number }) => `+${p.pct}%`,
  module_roll_graded: (p: { pct: string | number; grade: string | number }) => `+${p.pct}% ${p.grade}`,
  module_slot: (p: { module: string | number; tier: string | number }) => `${p.module} ${p.tier}`,
  module_tiers: ['I', 'II', 'III'],
  opens_base_tubes: 'the hold fires its own rounds',
  opens_build_slot: (p: { n: string | number }) => `build slot ${p.n}`,
  opens_module_slot: (p: { n: string | number }) => `${p.n} modules per design`,
  opens_oracle_share: 'press SHARE on an Oracle',
  opens_point_defence: 'the hold fires point defense by itself',
  opens_recv_fleet: 'read the squad\'s pooled rings',
  opens_recv_installation: 'receive the installation rings',
  opens_recv_warship: 'see your squad\'s warships',
  opens_share_fleet: 'your fleets\' rings join the pool',
  opens_shield_types: 'a draft picks a shield type',
  opens_tech_tier: (p: { n: string | number }) => `tech tier ${p.n}`,
  opens_weapon_types: 'a draft picks a weapon type',
  pens_section_empty: 'no hulls in the pens',
  pens_section_head: 'In the pens',
  pens_section_head_combat: (p: { w: string | number; cap: string | number }) => `In the pens · combat ${p.w}/${p.cap} weight`,
  pens_section_head_support: (p: { w: string | number; cap: string | number }) => `In the pens · support ${p.w}/${p.cap} weight`,
  pick_free: (p: { n: string | number }) => `${p.n} free ashore`,
  pick_kind: (p: { cls: string | number; n: string | number }) => `${p.cls} · ${p.n} FREE ASHORE`,
  pick_title: (p: { hull: string | number }) => `Captain for ${p.hull}`,
  poker_all_in: 'ALL IN',
  poker_all_in_armed: 'ALL IN?',
  poker_amount: 'amount',
  poker_bet: 'BET',
  poker_blinds: (p: { small: string | number; big: string | number }) => `the blinds are ${p.small} and ${p.big}`,
  poker_board: 'the board',
  poker_button: (p: { n: string | number }) => `the button is on seat ${p.n}`,
  poker_call: 'CALL',
  poker_call_amount: (p: { amount: string | number }) => `call ${p.amount}`,
  poker_check: 'CHECK',
  poker_fold: 'FOLD',
  poker_fold_armed: 'FOLD?',
  poker_half_pot: 'half pot',
  poker_min: 'MIN',
  poker_pot: 'POT',
  poker_raise: 'RAISE',
  poker_rake: (p: { pct: string | number; cap: string | number }) => `the house takes ${p.pct}% of a pot, at most ${p.cap}`,
  poker_say_low: (p: { sec: number }) => plural(p.sec, {
    one: `${p.sec} second left to act`,
    other: `${p.sec} seconds left to act`,
  }),
  poker_say_turn: (p: { sec: number }) => plural(p.sec, {
    one: `your turn · ${p.sec} second to act`,
    other: `your turn · ${p.sec} seconds to act`,
  }),
  poker_showdown: 'showdown',
  poker_timed_out: 'TIME · your hand folded',
  poker_top_up: 'TOP UP',
  poker_top_up_to: (p: { amount: string | number }) => `top up to ${p.amount}`,
  poker_top_up_when: 'you may top up at the end of a hand',
  poker_wait_after: (p: { name: string | number }) => `you act after ${p.name}`,
  poker_wait_deal: (p: { sec: string | number }) => `the next hand deals in ${p.sec}s`,
  poker_wait_folded: 'you folded · the hand plays on',
  poker_wait_next: 'you act next',
  poker_wait_players: 'waiting for more players',
  poker_wait_soon: 'the next hand follows',
  poker_wait_turn: (p: { name: string | number; sec: string | number }) => `${p.name} to act · ${p.sec}s`,
  poker_you_all_in: 'you are all in',
  poker_your_hand: 'your hand',
  prep_auto: 'auto',
  prep_no_captain: 'no captain',
  print_btn: (p: { runs: string | number }) => `PRINT x${p.runs}`,
  print_install_title: 'one-way: installing over an occupied slot destroys the print already there',
  print_installed: 'installed — this hull builds to it',
  print_inventor: (p: { name: string | number }) => `${p.name}'s pattern`,
  print_master: 'MASTER',
  print_no_modules: 'no modules',
  print_runs: (p: { n: string | number }) => `${p.n} runs`,
  print_spent: 'spent — this hull builds to the default pattern',
  prints_no_copies: 'No [[print|prints]] yet. Press PRINT on a master to make copies that build hulls.',
  prints_no_copies_first: 'No [[print|prints]] yet. A print is a copy of a master that builds hulls. Draft a design first.',
  prints_no_masters: 'No [[master|masters]] yet. Draft a design in INVENTION, and each invention files a master.',
  prints_shelf_head: (p: { shelf: string | number; held: string | number; slots: string | number }) => `${p.shelf} ${p.held}/${p.slots}`,
  production_building: 'no graph yet — a graph draws from the second survey',
  production_charting: 'reading the income record…',
  production_full: 'store full',
  production_full_in: (p: { left: string | number }) => `full in ${p.left}`,
  production_gathered: 'gathered',
  production_graph_label: (p: { name: string | number }) => `${p.name}: income per hour, mined and gathered`,
  production_graphs_head: 'Income · mined and gathered, per hour',
  production_head: 'Stores',
  production_head_aside: 'stock / cap',
  production_isotopes_src: 'from dives · no store cap',
  production_mined: 'mined',
  production_mint_src: 'while the build queue is idle',
  production_no_income: 'no income',
  production_no_rate: 'no figure',
  production_rate: (p: { rate: string | number }) => `${p.rate}/h`,
  quake_rule_1: 'Every fleet went back to the pens, and every hold moved to the middle of the map. The outer reach rings of each site stop. The clock counts to the end of the season, when the scores lock.',
  quake_rule_1_next: (p: { next: string | number }) => `The war economy starts in ${p.next}.`,
  quake_rule_2: 'The deposits are dead, and hulls build faster. Open water damages every hull at sea, so only a ship in the pens is safe. Shocks strike at the marked trench. Holds, installations and captured objects do not beam. The clock counts to the end of the season, when the scores lock.',
  quake_rule_3: 'The scores are locked. The shocks grow until no ship stays afloat, and the holds fall in with the ships in their pens.',
  queue_big_title: 'make the build queue larger',
  queue_budget: (p: { used: string | number; max: string | number }) => ` · wait ${p.used} of ${p.max}`,
  queue_cancel: 'CANCEL',
  queue_cancel_armed: 'CANCEL?',
  queue_cancel_blocked: (p: { job: string | number; succ: string | number }) => `${p.job} cannot be cancelled — ${p.succ} is queued behind it`,
  queue_earlier: 'earlier',
  queue_head: (p: { active: string | number; slots: string | number; budget: string | number }) => `QUEUE ${p.active}/${p.slots}${p.budget}`,
  queue_head_idle: 'QUEUE EMPTY',
  queue_idle: (p: { mint: string | number }) => `earns ${p.mint} ¤/h until you queue a job`,
  queue_idle_full: (p: { mint: string | number }) => `The queue is empty. An empty queue earns ${p.mint} ¤/h. Queue a job in BUILD.`,
  queue_later: 'later',
  queue_min_title: 'minimize the build queue',
  queue_move_blocked: (p: { job: string | number; pred: string | number }) => `${p.job} must build after ${p.pred}`,
  queue_restore_title: 'open the build queue',
  queue_rush: (p: { cost: string | number }) => `RUSH ¤${p.cost}`,
  queue_rush_blocked: (p: { job: string | number; pred: string | number }) => `${p.job} cannot be rushed — ${p.pred} must finish first`,
  queue_small_title: 'make the build queue smaller',
  queue_starts_in: (p: { span: string | number }) => `starts in ~${p.span}`,
  queue_to_bottom: 'to bottom',
  queue_to_top: 'to top',
  queue_waiting: 'queued',
  queue_waits_for: (p: { job: string | number }) => `waits for ${p.job}`,
  rate_per_hour: (p: { rate: string | number }) => `+${p.rate}/h`,
  recruitment_empty: 'the Recruiting Office has nobody waiting',
  recruitment_head: 'Cadets on offer',
  recruitment_next_offer: (p: { left: string | number }) => `the next berth fills in ${p.left}`,
  redraft_title: 'roll this slot again: a higher roll improves the master, and an equal or lower roll is discarded; the other slots keep their rolls',
  refuse_module_gate: (p: { family: string | number; tier: string | number; code: string | number; tech: string | number }) => `${p.family} ${p.tier} needs ${p.code} ${p.tech}`,
  refuse_module_slots: (p: { slots: number }) => plural(p.slots, {
    one: `this office fits ${p.slots} module`,
    other: `this office fits ${p.slots} modules`,
  }),
  refuse_no_price: 'name a price first',
  refuse_no_qty_price: 'name a quantity and a price first',
  release_armed: 'RELEASE?',
  rename_head: (p: { name: string | number }) => `RENAME ${p.name}`,
  rename_hint: (p: { prefix: string | number; min: string | number; max: string | number }) => `The hull keeps ${p.prefix}. A name has ${p.min} to ${p.max} letters, spaces, apostrophes and hyphens. Reports keep the old name.`,
  report_head_cache_note: 'REPORT THE CACHE NOTE',
  report_head_commander: (p: { name: string | number }) => `REPORT THE NAME ${p.name}`,
  report_head_fleet: (p: { name: string | number }) => `REPORT THE HULL NAME ${p.name}`,
  report_head_line: (p: { name: string | number }) => `REPORT A LINE OF ${p.name}`,
  report_head_seamount: (p: { name: string | number }) => `REPORT THE SEAMOUNT NAME ${p.name}`,
  res_credits: 'credits',
  role_artillery: 'artillery',
  role_brawler: 'brawler',
  role_command: 'command ship',
  role_skirmish: 'skirmisher',
  role_support: 'support',
  role_torpedo: 'torpedo boat',
  role_tower: 'tower',
  roles_artillery: 'artillery',
  roles_brawler: 'brawlers',
  roles_command: 'command ships',
  roles_skirmish: 'skirmishers',
  roles_support: 'support hulls',
  roles_torpedo: 'torpedo boats',
  roles_tower: 'towers',
  roulette_ball_on: (p: { number: string | number }) => `the ball is on ${p.number}`,
  roulette_bets_shut: 'the bets are shut',
  roulette_black: 'BLACK',
  roulette_clear: 'CLEAR',
  roulette_clear_armed: 'CLEAR?',
  roulette_column: 'COLUMN',
  roulette_corner: 'CORNER',
  roulette_double_zero: 'DOUBLE ZERO',
  roulette_dozen: 'DOZEN',
  roulette_even: 'EVEN',
  roulette_help_bet: 'pick a kind, then tap the cloth',
  roulette_help_rebet: 'places the bets of the last spin again',
  roulette_help_take: 'tap a bet in the list to take it back',
  roulette_help_two: 'SPLIT, CORNER and LINE take two taps',
  roulette_high: 'HIGH',
  roulette_last: 'LAST',
  roulette_line: 'LINE',
  roulette_low: 'LOW',
  roulette_no_bet: 'you had no bet on this spin',
  roulette_not_adjacent: 'these two numbers do not touch',
  roulette_odd: 'ODD',
  roulette_pays: (p: { pays: string | number }) => `pays ${p.pays} to one`,
  roulette_pick_second: (p: { number: string | number }) => `pick a second number beside ${p.number}`,
  roulette_place_bet: 'place a bet',
  roulette_rebet: 'REBET',
  roulette_red: 'RED',
  roulette_split: 'SPLIT',
  roulette_straight: 'STRAIGHT',
  roulette_street: 'STREET',
  roulette_take_back: 'TAKE BACK',
  roulette_two_corner: 'CORNER takes two taps: two numbers that meet at one corner',
  roulette_two_line: 'LINE takes two taps: one number in each of two rows that touch',
  roulette_two_split: 'SPLIT takes two taps: two numbers side by side',
  roulette_wheel_runs: 'the wheel runs',
  roulette_your_bets: (p: { amount: string | number }) => `your bets ${p.amount}`,
  roulette_zero: 'ZERO',
  routes_delete: '✕',
  routes_delete_armed: 'DELETE?',
  routes_delete_title: 'delete this course plot',
  routes_empty: 'No course plots yet. Plot a course with PLOT in ⋯ of a fleet, and press SAVE AS PLOT in its list of legs.',
  routes_head: (p: { n: string | number }) => `COURSE PLOTS · ${p.n}`,
  routes_hint_none: 'Select an own fleet to send it on a course plot.',
  routes_hint_send: (p: { name: string | number }) => `SEND sends ${p.name} on the course. One fleet for each press.`,
  routes_lane: 'LANE',
  routes_lane_by: (p: { name: string | number }) => `by ${p.name}`,
  routes_lane_full: (p: { n: string | number }) => `you keep at most ${p.n} shipping lanes: clear one first`,
  routes_lane_mark: '≋',
  routes_lane_off_title: 'mark this course plot as a shipping lane: your faction sees it, and pirates look for fleets on it',
  routes_lane_on_title: 'clear the shipping lane: it stays a course plot',
  routes_lane_quiet: 'quiet',
  routes_lane_ridge: 'a shipping lane cannot cross a ridge: move the legs off the rock',
  routes_lane_short: (p: { n: string | number }) => `a shipping lane needs at least ${p.n} legs`,
  routes_lanes_head: (p: { n: string | number }) => `SHIPPING LANES · ${p.n}`,
  routes_lanes_hint: 'Pirates look for fleets on shipping lanes. Every commander of your faction sees each lane.',
  routes_legs: (p: { n: string | number }) => `${p.n} legs`,
  routes_loops: (p: { n: string | number }) => `${p.n} loop parts`,
  routes_px: (p: { px: string | number }) => `${p.px} px`,
  routes_rename: 'RENAME',
  routes_road_head: (p: { road: string | number; who: string | number }) => `${p.road} · ${p.who}`,
  routes_send: 'SEND',
  routes_send_none: 'select an own fleet to send it on this course',
  routes_send_title: (p: { name: string | number }) => `send ${p.name} on this course`,
  routes_view: 'VIEW',
  routes_view_title: 'show this shipping lane on the map, and open its card',
  row_held: (p: { n: string | number }) => `×${p.n}`,
  row_held_title: 'the hulls of the class at sea, in the pens and in the build queue',
  row_lvl: (p: { level: string | number }) => `${p.level}`,
  row_lvl_label: (p: { level: string | number }) => `level ${p.level}`,
  row_lvl_queued_label: (p: { level: string | number; n: string | number }) => `level ${p.level}, ${p.n} more in the queue`,
  row_queued: (p: { n: string | number }) => `+${p.n}`,
  row_short_in: (p: { wait: string | number }) => `in ${p.wait}`,
  scrap_armed: 'SCRAP?',
  seaobject_uses: ['A sea mine that detonates on the hull or the round that touches it.', 'A sea mine that detonates on contact and slows the hull it strikes.', 'A sea mine that detonates when a loud hull comes near. A quiet hull can pass it.', 'A heavy sea mine. Its splash sets off every sea mine inside it.', 'A net line. A hull inside it moves slowly, and for a time after it leaves.', 'A disc of spikes. A hull inside it loses hull and moves slowly.', 'An anchored listener that hears hulls for its faction.', 'A light on an own shipping lane. Own fleets near it move faster on the lane.', 'A false contact. Hostile sonar hears it as a hull.', 'A wall. No hull passes it, and a round detonates on it.'],
  shelf_copies: 'Prints',
  shelf_masters: 'Masters',
  short_needs: (p: { missing: string | number }) => `needs ${p.missing} more`,
  short_needs_wait: (p: { missing: string | number; wait: string | number }) => `needs ${p.missing} more · in ${p.wait}`,
  shot_every: (p: { dmg: string | number; sec: string | number }) => `${p.dmg} a shot, every ${p.sec} combat s`,
  site_kinds: ['Faction installation', 'Deposit', 'Control point', 'Hold'],
  slot_empty: 'empty',
  slot_empty_key: (p: { key: string | number }) => `${p.key}`,
  slot_empty_title: (p: { n: string | number; key: string | number }) => `group ${p.n} is empty · select a fleet, then hold here or press ${p.key}`,
  slot_replaced: (p: { name: string | number; n: string | number; left: string | number }) => `${p.name} holds group ${p.n} · ${p.left} left it`,
  slot_set: (p: { name: string | number; n: string | number }) => `${p.name} holds group ${p.n}`,
  slot_sig_docked: (p: { order: string | number }) => `${p.order} · the hull is in the pens`,
  slot_sig_none: (p: { name: string | number }) => `${p.name} has no signature order`,
  slot_sig_state: (p: { order: string | number; state: string | number }) => `${p.order} · ${p.state}`,
  slot_tip: 'select a fleet, then hold a slot to set it',
  slot_title: (p: { name: string | number }) => `${p.name} · press to select, press again to centre · hold to set`,
  slot_undo: 'UNDO',
  slots_help_pull: 'one stake, and the pull settles at once',
  slots_line_pays: (p: { pays: string | number }) => `the line pays ${p.pays}`,
  slots_no_line: 'no line',
  slots_pulls: (p: { count: number }) => plural(p.count, {
    one: `you pulled ${p.count} time`,
    other: `you pulled ${p.count} times`,
  }),
  slots_reels_run: 'the reels run',
  slots_rtp: (p: { pct: string | number }) => `this machine pays back ${p.pct}% over time`,
  slots_spin: 'SPIN',
  slots_sym_anchor: 'anchor',
  slots_sym_any: 'any symbol',
  slots_sym_blank: 'blank',
  slots_sym_kraken: 'kraken',
  slots_sym_pearl: 'pearl',
  slots_sym_shell: 'shell',
  slots_sym_trident: 'trident',
  slots_three_pay: (p: { symbol: string | number; pays: string | number }) => `${p.symbol} three times · pays ${p.pays}`,
  sov_charting: 'charting the sea floor…',
  sov_head: 'Sovereignty · the sea today',
  sov_legend_count: (p: { count: string | number; pct: string | number }) => `${p.count} · ${p.pct}%`,
  sov_line_building: 'the line draws from the second survey',
  sov_line_label: 'cells each faction holds over the season',
  sov_no_samples: 'no samples yet',
  sov_pie_label: 'cells owned per faction',
  sov_series_head: 'Season series · cells each faction holds',
  sov_slice_title: (p: { name: string | number; count: string | number; pct: string | number }) => `${p.name} — ${p.count} cells (${p.pct}%)`,
  standings_flag_key: '⚑ beside a name opens a report of that name.',
  standings_held: 'held',
  standings_history: 'History',
  standings_history_placeholder: 'ship logbooks, captain diaries, player records — placeholder (2026-08-21)',
  standings_no_captures: 'no captures scored yet',
  standings_resets: (p: { left: string | number }) => ` · resets in ${p.left}`,
  standings_row_sub: (p: { cells: string | number; kills: string | number; sieges: string | number }) => `${p.cells} cells taken · ${p.kills} kills · ${p.sieges} sieges won`,
  standings_seaquake: 'SEAQUAKE',
  standings_season: (p: { season: string | number }) => `Season ${p.season}`,
  standings_taken: 'taken',
  standings_top_commanders: 'Top commanders',
  standings_top_squads: 'Top squads',
  standings_who: 'who',
  standings_you: 'you',
  standings_you_line: (p: { rank: string | number; score: string | number; title: string | number }) => `place ${p.rank} · ${p.score} pts · Honour rank ${p.title}`,
  standings_you_title: 'Your row',
  stow_held: (p: { n: string | number }) => `held ${p.n}`,
  stow_less: (p: { name: string | number }) => `one ${p.name} less`,
  stow_line_item: (p: { name: string | number; n: string | number }) => `${p.name} ${p.n}`,
  stow_max: (p: { name: string | number }) => `as many ${p.name} as fit`,
  stow_more: (p: { name: string | number }) => `one ${p.name} more`,
  stow_note_auto: 'AUTO stows each kind of the Depot stock in kind order, as many as fit.',
  stow_note_full: 'The Depot holds all items in this loadout. The Sapper sails with what the Depot holds.',
  stow_note_no_depot: 'The Depot opens no kind of sea object yet. Build the Depot to fill the loadout.',
  stow_note_short: 'The Depot holds fewer items than this loadout. The Sapper sails with what the Depot holds.',
  stow_title: (p: { hull: string | number }) => `LOADOUT · ${p.hull}`,
  stow_weight: (p: { n: string | number }) => `${p.n} cargo`,
  structures_attacked: (p: { who: string | number }) => `${p.who} attacks`,
  structures_contested_head: 'Contested',
  structures_empty: 'no objects charted yet',
  structures_enemy_pledged: 'another faction has pledged',
  structures_enemy_short: 'enemy pledged',
  structures_head: 'Strategic objects',
  structures_held_by: (p: { who: string | number }) => `held by ${p.who}`,
  structures_own_pledges: (p: { own: string | number }) => `${p.own} pledged by your faction`,
  structures_plan_head: (p: { fleet: string | number }) => `${p.fleet} · battle plan`,
  structures_pledged_short: (p: { own: string | number }) => `${p.own} pledged`,
  structures_win_hour: (p: { hour: string | number }) => `${p.hour}:00`,
  structures_win_in: (p: { left: string | number }) => `in ${p.left}`,
  structures_win_left: (p: { left: string | number }) => `${p.left} left`,
  structures_win_open: 'OPEN',
  structures_window: (p: { hour: string | number; left: string | number }) => `window ${p.hour}:00 · in ${p.left}`,
  structures_window_open: 'WINDOW OPEN',
  structures_your_pledge: 'your pledge stands',
  structures_your_short: 'your pledge',
  structures_yours: ' (yours)',
  sub_auction: 'AUCTION',
  sub_base: 'BASE',
  sub_casino: 'CASINO',
  sub_commissions: 'COMMISSIONS',
  sub_depot: 'DEPOT',
  sub_expeditions: 'EXPEDITIONS',
  sub_intel: 'INTEL',
  sub_invention: 'INVENTION',
  sub_masters: 'MASTERS',
  sub_missions: 'MISSIONS',
  sub_prints: 'PRINTS',
  sub_prison: 'BRIG',
  sub_production: 'PRODUCTION',
  sub_recruitment: 'RECRUITMENT',
  sub_reports: 'REPORTS',
  sub_routes: 'ROUTES',
  sub_shipyard: 'SHIPYARD',
  sub_sovereignty: 'SOVEREIGNTY',
  sub_structures: 'STRUCTURES',
  sub_tech: 'TECH',
  sub_torpedo: 'TORPEDO',
  sub_treasure: 'TREASURE',
  sub_wardroom: 'WARDROOM',
  tab_build: 'BUILD',
  tab_captain: 'CAPTAIN',
  tab_draft: 'DRAFT',
  tab_economy: 'ECONOMY',
  tab_fleet: 'FLEET',
  tab_installations: 'Installations',
  tab_short_build: 'BUILD',
  tab_short_captain: 'CAPT',
  tab_short_draft: 'DRAFT',
  tab_short_economy: 'ECON',
  tab_short_fleet: 'FLEET',
  tab_short_war: 'WAR',
  tab_waits_said: (p: { name: string | number }) => `${p.name}, WAITS`,
  tab_war: 'WAR',
  tab_why_build_queue: 'The build queue is empty.',
  tab_why_captain_cadet: 'A cadet waits for a free captain slot.',
  tab_why_captain_fit: 'A captain is fit again.',
  tab_why_fleet_idle: 'A fleet at sea has no mission.',
  tab_why_fleet_wear: 'A damaged hull waits in the pens.',
  tab_why_fleet_withdraw: 'A fleet withdraws.',
  tab_why_war_window: 'A siege window that concerns you stands open.',
  tech_decrypting: 'decrypting…',
  tech_keys_held: (p: { code: string | number }) => `${p.code} held`,
  tech_keys_note: 'A [[keystone]] is the top node of a branch. You hold one a season, and the choice is final.',
  tech_keys_one: 'one a season',
  tech_keys_open: (p: { n: string | number }) => `${p.n} open`,
  tech_keys_queued: (p: { code: string | number }) => `${p.code} in the queue`,
  tech_keystone_held: 'this season\'s keystone',
  tech_keystone_taken: 'another keystone stands',
  tech_keystones: 'Keystones',
  tech_needs_lab: (p: { level: string | number }) => `needs Research Lab level ${p.level}`,
  tech_next_head: 'Research next',
  tech_next_lab_build: 'Build a Research Lab to start research.',
  tech_next_lab_raise: (p: { level: string | number; name: string | number }) => `Raise the Research Lab to level ${p.level} to open ${p.name}.`,
  tech_next_wait: 'The next node opens when the research in the queue is done.',
  tech_recovered: 'recovered',
  tech_requires: (p: { codes: string | number }) => `requires ${p.codes}`,
  torpedo_head_hold: (p: { cap: string | number }) => `Hold magazines · ${p.cap} per type`,
  torpedo_head_ship: (p: { w: string | number; cap: string | number }) => `Ship magazines · ${p.w}/${p.cap}`,
  torpedo_use: (p: { firers: string | number; use: string | number }) => `${p.firers} · ${p.use}`,
  trs_caches_empty: 'You left no cache this season. CACHES in the ⋯ of an own fleet card leaves one.',
  trs_found_empty: 'No hull of yours took a cache this season.',
  trs_found_hide: 'HIDE',
  trs_found_show: (p: { n: string | number }) => `SHOW ${p.n}`,
  trs_fragment_name: (p: { den: string | number }) => `Chart fragment · den ${p.den}`,
  trs_fragment_points: (p: { cell: string | number }) => `points to the pirate cache at ${p.cell}`,
  trs_fragment_taken: 'taken this season',
  trs_fragments_empty: 'You hold no chart fragment. The commander of the last hit on a pirate hull gets the fragment of its den.',
  trs_head_caches: (p: { n: string | number }) => `YOUR CACHES · ${p.n}`,
  trs_head_found: (p: { n: string | number }) => `FOUND · ${p.n}`,
  trs_head_fragments: (p: { n: string | number }) => `CHART FRAGMENTS · ${p.n}`,
  trs_head_wrecks: (p: { n: string | number }) => `WRECKS WITH CARGO · ${p.n}`,
  trs_hint: 'SEARCH in the ⋯ of a combat ship or a Dredger, or on the peek of water, sends a fleet to search a cell. A SEARCH finds a cache and recovers cargo from the wrecks nearby. A cache holds no resources: the finder takes a reward of the game, and the hull carries it home as compressed cargo.',
  trs_search: 'SEARCH',
  trs_search_title: 'pick a combat ship or a Dredger that sails to the wreck and searches there: it recovers part of the cargo of the wrecks nearby',
  trs_view: 'VIEW',
  trs_view_title: 'centre the map on this cell',
  trs_wreck_cells: (p: { n: number }) => plural(p.n, {
    one: `${p.n} cell`,
    other: `${p.n} cells`,
  }),
  trs_wrecks_empty: 'Your sonar heard no wreck with cargo. A wreck of the last world day stands here when your sonar hears its cargo on a surveyed cell.',
  truce: (p: { left: string | number }) => `<span class="mark">FOUNDING TRUCE</span> · weapons free in ${p.left}`,
  truce_first: (p: { left: string | number }) => `Founding truce: nobody can attack you for ${p.left}.`,
  truce_tab: (p: { left: string | number }) => `TRUCE · ${p.left}`,
  wardroom_academy: (p: { level: string | number }) => `Academy ${p.level}`,
  wardroom_empty: 'no captains under contract',
  wardroom_head: (p: { n: string | number; cap: string | number }) => `Wardroom ${p.n}/${p.cap}`,
  warlog_collapse: 'LAST 3',
  warlog_expand: (p: { n: string | number }) => `LAST ${p.n}`,
  why_depot_rack_full: 'the Depot rack is full',
  why_needs_banks: 'needs a Torpedo Battery',
  why_needs_base: (p: { level: string | number }) => `needs Command Centre ${p.level}`,
  why_needs_depot: (p: { level: string | number }) => `needs Depot ${p.level}`,
  why_needs_foundations: 'needs next Foundations node',
  why_needs_shipyard: (p: { level: string | number }) => `needs Shipyard ${p.level}`,
  why_needs_tech: (p: { tech: string | number }) => `needs ${p.tech}`,
  why_rack_full: 'the ship-round rack is full',
  word_a_doctrine: 'a doctrine',
  word_auto: 'AUTO',
  word_beacon: 'beacon',
  word_certification: 'certification',
  word_doctrine: 'doctrine',
  word_hold: 'hold',
  word_off: 'OFF',
  word_on: 'ON',
  word_open_sea: 'the open sea',
  word_open_water: 'open water',
  word_tech: 'tech',
  word_torpedobanks: 'Torpedo Battery',
  word_unclaimed: 'unclaimed',
  yard_autorebuild: 'Auto-rebuild',
  yard_autorebuild_what: 'a lost hull re-queues at the head',
  yard_cap: (p: { n: string | number }) => `${p.n} per empire`,
  yard_empty: 'no Shipyard',
  yard_head: 'Yard settings',
  yard_print: (p: { runs: string | number; fit: string | number }) => `${p.runs}× ${p.fit}`,
  yard_spent: 'print spent · default pattern',
  yard_weight: (p: { weight: string | number }) => `w${p.weight}`,
};

const photo_en: S.Photo = {
  brand: 'AQUAPHOBIA',
  grid: 'GRID',
  grid_title: 'draw the hex lines',
  hint: 'PHOTO MODE · ESC LEAVES',
  leave: 'LEAVE',
  leave_title: 'leave photo mode',
  mark: 'MARK',
  mark_line: (p: { world: string | number; season: string | number; day: string | number }) => `${p.world} · SEASON ${p.season} · DAY ${p.day}`,
  mark_title: 'put the mark on the saved picture',
  save: 'SAVE PNG',
  save_failed: 'THE PICTURE WAS NOT SAVED',
  saved: 'SAVED',
  zoom: 'zoom',
  zoom_value: (p: { zoom: string | number }) => `${p.zoom}×`,
};

const quickchat_en: S.Quickchat = {
  faction: 'FACTION',
  line_attack: 'Attack here.',
  line_coming: 'On my way.',
  line_defend: 'Hold at home.',
  line_enemy: 'Enemy fleet sighted.',
  line_help: 'Help at my marker.',
  line_no: 'No.',
  line_regroup: 'Regroup at my marker.',
  line_siege: 'Siege at H-hour.',
  line_wait: 'Wait for me.',
  line_well_done: 'Well done.',
  line_withdraw: 'I withdraw.',
  line_yes: 'Yes.',
  needs_attack: 'place a map marker or select a fleet of yours first',
  needs_coming: 'select a fleet of yours first',
  needs_defend: 'you have no hold on this map',
  needs_enemy: 'select a contact or place a map marker first',
  needs_help: 'place a map marker first',
  needs_regroup: 'place a map marker first',
  needs_siege: 'place a map marker on a strategic object first',
  needs_withdraw: 'select a fleet of yours first',
  pos_cell: (p: { pos: string | number }) => `⌖ ${p.pos}`,
  pos_name: (p: { name: string | number }) => `⌖ ${p.name}`,
  pos_siege: (p: { hour: string | number; name: string | number }) => `${p.hour}:00 · ${p.name}`,
  pos_title: 'move the camera to this position',
  squad: 'SQUAD',
  wheel_label: 'quick lines',
  word_attack: 'ATTACK',
  word_coming: 'ON MY WAY',
  word_defend: 'HOLD',
  word_enemy: 'ENEMY',
  word_help: 'HELP',
  word_no: 'NO',
  word_regroup: 'REGROUP',
  word_siege: 'H-HOUR',
  word_wait: 'WAIT',
  word_well_done: 'WELL DONE',
  word_withdraw: 'WITHDRAW',
  word_yes: 'YES',
};

const relayMark_en: S.RelayMark = {
  line: '→ DISCORD · Each new line goes to a Discord channel of the clan.',
  mark: '→ DISCORD',
  title: 'The chat relay of the clan is on: each new line of this chat goes to a Discord channel of the clan, where other people can read it.',
};

const replay_en: S.Replay = {
  clock: (p: { at: string | number; total: string | number; rate: string | number }) => `${p.at}s / ${p.total}s · ${p.rate}x`,
  col_commander: 'COMMANDER',
  col_damage: 'DMG',
  col_faction: 'FACTION',
  col_hits: '×',
  col_hull: 'HULL',
  col_kind: 'KIND',
  col_shield: 'SHIELD',
  col_source: 'SOURCE',
  col_time: 'TIME',
  exit_title: 'leave the film',
  film_tag: 'REPLAY',
  loop_label: (p: { n: string | number }) => `LOOP ${p.n}`,
  monster: 'monster',
  nobody: 'nobody',
  pause_title: 'pause',
  play_title: 'play',
  report_label: 'REPORT',
  report_title: 'DAMAGE REPORT',
  report_toggle_title: 'show or hide the damage report',
  restart_in: (p: { n: string | number }) => `REPLAY IN ${p.n}`,
  restart_title: 'play it from the start',
  scrub_title: 'go to a time',
  span: (p: { from: string | number; to: string | number }) => `${p.from}→${p.to}`,
  stop_title: 'stop, and go back to the start',
};

const replayPage_en: S.ReplayPage = {
  failed: 'The replay did not load. Try the link again in a minute.',
  gone: 'This replay is no longer kept. The arcade keeps a replay for a limited time.',
  loading: 'READING THE MATCH',
  no_code: 'This link names no match. Check that you copied the whole link.',
  play_arcade: 'PLAY THE ARCADE',
  title: 'ARCADE REPLAY',
  way_in: '<b>New to Aquaphobia?</b> A guest plays the arcade at once, with no account.',
};

const reportSheet_en: S.ReportSheet = {
  always: 'always: your account, the build, the browser',
  always_sub: (p: { account: string | number; build: string | number; browser: string | number }) => `account ${p.account} · build ${p.build} · ${p.browser}`,
  always_sub_guest: (p: { account: string | number; build: string | number; browser: string | number }) => `guest account ${p.account} · build ${p.build} · ${p.browser}`,
  cancel: 'CANCEL',
  carries: 'THE REPORT CARRIES',
  close: 'CLOSE',
  close_title: 'close',
  copied: 'COPIED',
  copy_ref: 'COPY REFERENCE',
  count: (p: { count: string | number; max: string | number }) => `${p.count} / ${p.max}`,
  fine: 'ONE REPORT A MINUTE',
  fleets: 'the selected fleets',
  fleets_none: 'no fleet is selected',
  happened: 'WHAT HAPPENED',
  happened_hint: 'what you did, and what the game did',
  kind: 'WHAT KIND',
  lede: 'Tell us what went wrong. The report goes to the team that runs the game, with the facts of this moment below.',
  limit_device: (p: { wait: string | number }) => `This device sent a report less than a minute ago. The sheet keeps your words; SEND works again in ${p.wait}.`,
  limit_head: 'NOT SENT YET',
  limit_server: (p: { wait: string | number }) => `The server takes no more reports from this account for a while. The sheet keeps your words; SEND works again in ${p.wait}.`,
  log: 'the client log',
  log_sub: (p: { lines: string | number; size: string | number }) => `the last ${p.lines} lines · ${p.size}`,
  nettest_line: 'A connection problem? The network check tests the path from this device to the game, and sends the result.',
  nettest_link: 'OPEN THE NETWORK CHECK',
  outbox_sent: (p: { ref: string | number }) => `The waiting report went out. Its reference is ${p.ref}.`,
  pick_kind: 'pick what kind of problem first',
  refused: (p: { reason: string | number }) => `The server did not take the report: ${p.reason}`,
  send: 'SEND',
  send_wait: (p: { wait: string | number }) => `SEND · ${p.wait}`,
  sending: 'SENDING',
  sent_body: 'The team reads every report. Give this reference to the team if you write to us about it.',
  sent_fleets: (p: { count: number }) => plural(p.count, {
    one: `${p.count} selected fleet`,
    other: `${p.count} selected fleets`,
  }),
  sent_head: 'REPORT SENT',
  sent_with: (p: { list: string | number }) => `It went out with: ${p.list}.`,
  shot: 'a screenshot',
  shot_none: 'the map was not drawn, so there is no screenshot',
  shot_sub: 'the map as it stood when this sheet opened',
  size_kb: (p: { kb: string | number }) => `${p.kb} KB`,
  tick: 'the world tick',
  tick_sub: (p: { world: string | number; tick: string | number; day: string | number; clock: string | number }) => `${p.world} · tick ${p.tick} · day ${p.day} ${p.clock}`,
  title: 'REPORT A PROBLEM',
  topic_balance: 'BALANCE',
  topic_bug: 'BUG',
  topic_connection: 'CONNECTION',
  topic_controls: 'CONTROLS',
  topic_display: 'DISPLAY',
  topic_other: 'OTHER',
  wait_body: 'The link to the server is down. The report waits on this device and goes out when the link comes back. Nothing more to do.',
  wait_head: 'THE REPORT WAITS',
};

const seamarks_en: S.Seamarks = {
  area_enemy_mines: 'Enemy mines',
  area_hostile_sea_mines: 'HOSTILE SEA MINES',
  area_mined: 'Mined',
  area_sea_mines: 'SEA MINES',
  heard: 'HEARD',
  hostile: 'HOSTILE',
  light_char: 'Fl 4s',
  light_char_historical: 'Fl.4s',
  mul: (p: { mul: string | number }) => `×${p.mul}`,
  no_room: 'NO ROOM',
  of_cap: (p: { cap: string | number }) => `/${p.cap}`,
  plus: (p: { n: string | number }) => `+${p.n}`,
  quiet_take: (p: { n: string | number; stow: string | number; cap: string | number }) => `+${p.n} · ${p.stow}/${p.cap}`,
  radius: (p: { r: string | number }) => `R${p.r}`,
  tally: (p: { rank: string | number; cargo: string | number }) => `${p.rank} · ${p.cargo}`,
};

const seamountName_en: S.SeamountName = {
  first: ['Anvil', 'Ash', 'Bell', 'Bone', 'Brass', 'Cinder', 'Cobalt', 'Coral', 'Crown', 'Dawn', 'Drift', 'Echo', 'Ember', 'Fathom', 'Flint', 'Frost', 'Ghost', 'Glass', 'Gull', 'Harrow', 'Iron', 'Kelp', 'Lantern', 'Marrow', 'Mist', 'Night', 'Obsidian', 'Oyster', 'Pearl', 'Raven', 'Salt', 'Shadow', 'Silver', 'Slate', 'Storm', 'Thunder', 'Tide', 'Warden', 'Whale', 'Wraith'],
  pattern: (p: { first: string | number; second: string | number }) => `${p.first} ${p.second}`,
  second: ['Bank', 'Crag', 'Crest', 'Dome', 'Fang', 'Head', 'Horn', 'Keel', 'Knoll', 'Mount', 'Peak', 'Pillar', 'Pinnacle', 'Ridge', 'Rise', 'Rock', 'Shoal', 'Spire', 'Spur', 'Summit', 'Table', 'Throne', 'Tor', 'Tower'],
};

const seasonSummary_en: S.SeasonSummary = {
  ach_loading: 'The achievement record loads.',
  ach_more: (p: { n: string | number }) => `+${p.n} MORE`,
  ach_no_record: 'The achievement record is not available.',
  ach_none: 'No achievement grade this season.',
  all_zero: 'Nothing counted this season.',
  banner_house: 'HOUSE',
  banner_seats: (p: { seats: number }) => plural(p.seats, {
    one: `${p.seats} seat`,
    other: `${p.seats} seats`,
  }),
  btn_chronicle: 'CHRONICLE',
  btn_chronicle_after_roll: 'OPENS AFTER THE ROLL',
  btn_close: 'VIEW MAP',
  btn_menu: 'MENU',
  btn_open: 'SEASON SUMMARY',
  captains_lost: (p: { n: number }) => plural(p.n, {
    one: `${p.n} captain lost this season.`,
    other: `${p.n} captains lost this season.`,
  }),
  carry_asking: '…',
  carry_captains: (p: { n: string | number }) => `CAPTAINS · ${p.n}`,
  carry_clan_honour: 'CLAN HONOUR',
  carry_honour: 'HONOUR',
  carry_honour_total: (p: { total: string | number }) => `${p.total} after the roll`,
  carry_lost_none: 'No captain lost this season.',
  carry_more: (p: { n: string | number }) => `+${p.n} MORE`,
  carry_no_captain: 'No captain crosses with you.',
  carry_risk: (p: { pct: string | number }) => `may retire · ${p.pct}%`,
  compare: ['POINTS', 'CELLS TAKEN', 'SUNK', 'SIEGES', 'GATHERED'],
  held_line: 'THE SEASON IS OVER',
  honour_value: (p: { honour: string | number }) => `+${p.honour}`,
  kick: (p: { mode: string | number; world: string | number }) => `${p.mode} · ${p.world}`,
  mode_clanwar: 'CLAN WAR',
  mode_core: 'CONQUEST',
  mode_custom: 'CUSTOM',
  mode_event: 'EVENT',
  next_in: (p: { left: string | number }) => `NEW SEASON IN ${p.left}`,
  next_now: 'THE NEW SEASON STARTS NOW',
  ordinal: ['th', 'st', 'nd', 'rd'],
  place: (p: { rank: string | number; of: string | number }) => `${p.rank} of ${p.of}`,
  place_clan: 'CLAN',
  place_faction: 'FACTION',
  place_you: 'YOU',
  road_builder: (p: { name: string | number; h: string | number }) => `Road builder of your faction: ${p.name}, with ${p.h} fleet hours lifted on the lanes.`,
  row_you: 'YOU',
  score_by_source: 'SCORE BY SOURCE',
  second: 'SECOND PLACE',
  section_achievements: 'ACHIEVEMENTS THIS SEASON',
  section_banners: 'CLAN RANKING',
  section_carry: 'YOU CARRY INTO THE NEXT SEASON',
  section_place: 'YOUR PLACE IN THE SEA',
  section_top: (p: { rows: string | number }) => `FINAL RANKING · TOP ${p.rows}`,
  section_you: 'YOUR SEASON',
  share: (p: { share: string | number }) => `You hold ${p.share} of the winner's score.`,
  share_pct: (p: { pct: string | number }) => `${p.pct}%`,
  share_second: (p: { share: string | number }) => `You hold ${p.share} of the second place's score.`,
  sources: ['Territory', 'Kills', 'Sieges', 'Gathering', 'Expeditions', 'Buildings', 'Tech', 'Throne', 'Captains', 'Survey', 'Finds', 'Commissions', 'Caches'],
  stat_buildings: 'Building levels',
  stat_cells: 'Cells taken',
  stat_expeditions: 'Expeditions',
  stat_fleets_lost: 'Fleets lost',
  stat_gathered: 'Resources gathered',
  stat_kills: 'Fleets sunk',
  stat_prisoners: 'Prisoners taken',
  stat_sieges_lost: 'Sieges lost',
  stat_sieges_won: 'Sieges won',
  stat_tech: 'Tech recovered',
  stat_throne: 'Hours on the Throne',
  stat_trades: 'Trades',
  vs: 'against',
  winner: 'THE WINNER',
  winner_clan: (p: { name: string | number }) => `The winner, ${p.name}, sails in your clan.`,
  winner_faction: (p: { name: string | number }) => `The winner, ${p.name}, sails in your faction.`,
  you_unranked: 'You joined after the scores locked. The final table does not rank you.',
  you_won: 'You won the season.',
};

const settlement_en: S.Settlement = {
  kick: 'THE QUAKE HAS WON',
  line: (p: { left: string | number }) => `The sea takes the board. The season summary opens in ${p.left}.`,
};

const share_en: S.Share = {
  copied_code: 'CODE COPIED',
  copied_link: 'LINK COPIED',
  copy_failed: 'THIS BROWSER WOULD NOT COPY IT',
  shared: 'SHARED',
};

const siege_en: S.Siege = {
  alarm_what_open: (p: { target: string | number; at: string | number }) => `${p.target} · closes ${p.at}`,
  alarm_what_shut: (p: { target: string | number; at: string | number }) => `${p.target} · opens ${p.at}`,
  featured_tag: 'FEATURED ×2',
  featured_title: 'The featured object of the day: double bonus for the faction that holds it, double siege score for a won window.',
  foes_none: 'no pledge seen',
  foes_pledged: 'pledged',
  foes_seen: (p: { n: string | number }) => `${p.n} in sight`,
  glyph: '⌖',
  head_label: 'next siege window',
  in: 'I\'M IN',
  in_set: 'YOU\'RE IN',
  in_title: 'tell your squad that you will be there for this window; it books no pledge',
  none_mine: 'No window concerns your faction. Send a hull to an object, or pledge while its window is open.',
  none_set: 'No siege window is set on this map.',
  out_title: 'take back your commitment to this window',
  own_near: (p: { n: string | number }) => `${p.n} near`,
  own_pledged: (p: { n: string | number }) => `${p.n} pledged`,
  rally: 'RALLY',
  rally_notice: (p: { target: string | number }) => `Rally sent to your squad: a marker on ${p.target} and the H-hour line.`,
  rally_sent: 'SENT',
  rally_title: 'mark the object for your squad and send the H-hour line to SQUAD',
  ready_in: (p: { state: string | number }) => `${p.state} · in`,
  ready_near: 'near the target',
  ready_offline: 'offline',
  ready_online: 'online',
  ready_reserve: 'reserve',
  ready_sea: 'hull in view',
  ready_you: (p: { state: string | number }) => `you · ${p.state}`,
  role_attack: 'ATTACK',
  role_defend: 'DEFEND',
  role_free: 'UNCLAIMED',
  role_held: (p: { faction: string | number }) => `HELD BY ${p.faction}`,
  role_near: 'YOUR HULLS NEAR',
  show: 'SHOW',
  show_title: 'centre the map on the object',
  side_foes: 'FOES',
  side_own: 'YOUR SIDE',
  squad_in: (p: { n: string | number }) => `${p.n} in`,
  squad_none: 'No window concerns your faction.',
  squad_window: (p: { at: string | number; target: string | number }) => `WINDOW ${p.at} · ${p.target}`,
  squad_window_open: (p: { at: string | number; target: string | number }) => `OPEN · CLOSES ${p.at} · ${p.target}`,
  target: (p: { kind: string | number; site: string | number }) => `${p.kind} · ${p.site}`,
  timer_label: 'SIEGE WINDOW',
  timer_sentence_open: (p: { target: string | number; at: string | number; left: string | number }) => `Siege window · ${p.target} · open · closes ${p.at} · in ${p.left}`,
  timer_sentence_shut: (p: { target: string | number; at: string | number; left: string | number }) => `Siege window · ${p.target} · opens ${p.at} · in ${p.left}`,
  timer_short: 'WINDOW',
  timer_tail_open: 'until the window closes',
  timer_tail_shut: 'until the window opens',
  when_open: (p: { close: string | number }) => `OPEN NOW · closes ${p.close}`,
  when_shut: (p: { open: string | number; close: string | number }) => `opens ${p.open} · closes ${p.close}`,
};

const sonarlab_en: S.Sonarlab = {
  add: (p: { kind: string | number }) => `+ ${p.kind}`,
  add_title: (p: { kind: string | number }) => `add a ${p.kind} at the middle of the map`,
  band_abyss: 'abyss',
  band_deep: 'deep',
  band_shelf: 'shelf',
  band_slope: 'slope',
  card_baffled: (p: { hearing: string | number }) => `This hull is under way. It hears its rear 90° only inside ${p.hearing} of its reach.`,
  card_band: 'depth band',
  card_contacts: 'contacts',
  card_noise: 'noise',
  card_noise_of: (p: { id: string | number }) => `noise of ${p.id}`,
  card_range: 'range',
  card_range_of: (p: { id: string | number }) => `range of ${p.id}`,
  card_thermo: 'thermocline',
  card_typed: 'typed system',
  card_waiting: 'The engine has not answered yet.',
  cause_baffles: 'in the baffles of the listener',
  cause_deep_run: 'a fixed listener does not hear a deep run',
  cause_heard: 'heard',
  cause_hidden: 'the hull hides',
  cause_inert: 'the listener is inert and hears for nobody',
  cause_range: 'out of reach',
  column_hide: 'HIDE COLUMN',
  column_hint: 'the map takes the width',
  column_show: 'SHOW COLUMN',
  copy_link: 'COPY LINK',
  copy_link_title: 'copy a link to this picture',
  defaults: 'DEFAULTS',
  defaults_hint: 'the first lesson',
  dice_title: 'a random seed',
  engine_error: (p: { error: string | number }) => `the sonar engine recovered from a fault: ${p.error}`,
  engine_failed: (p: { error: string | number }) => `the sonar engine failed: ${p.error}`,
  engine_loading: 'the sonar engine loads…',
  engine_missing: (p: { why: string | number }) => `no sonar engine: run scripts/build-battlelab-wasm.sh, then load the page again (${p.why})`,
  engine_ms: (p: { ms: string | number }) => `the engine answered in ${p.ms} ms`,
  engine_no_world: 'the engine gave no world size',
  export_hint: 'every preset, as one file',
  field_more: '3+',
  fit: 'FIT',
  fit_hint: 'frame the units on the screen',
  fold_how: 'how sonar works',
  fold_keys: 'keys',
  fold_presets: 'presets',
  fold_scene: 'lesson',
  fold_unit: 'unit',
  fold_units: 'units',
  fold_world: 'world',
  how_baffles: (p: { hearing: string | number }) => `A hull under way is almost deaf in its rear 90°, the baffles: there it hears a hull only inside ${p.hearing} of its reach. A still hull and a fixed listener hear all round. The wake behind a hull shows where its baffles are.`,
  how_deep_run: 'A fixed listener does not hear a hull on a deep run: a hold, an installation, a Relay Spire and a Hark. A hull at sea still hears it.',
  how_depth: (p: { bands: string | number }) => `With the flag depth on, the map has four depth bands. A hull in a deeper band makes less noise: ${p.bands}. A reach from one band into another takes the thermocline factor of the table below, so a reach ring steps at each band edge.`,
  how_field: 'The heard field shows where the watched hull is heard. The page puts a copy of the watched hull, with all its settings, at the middle of each field cell and asks every listener of another faction. A darker tint shows more listeners. At the edge, the distance and the reach are equal.',
  how_fixed: (p: { base: string | number; per: string | number; max: string | number; installation: string | number; spire: string | number; buoy: string | number }) => `A hold hears ${p.base} px, and ${p.per} px more for each Sonar Station level, up to level ${p.max}. A faction installation hears ${p.installation} px, a held Relay Spire ${p.spire} px and a Hark ${p.buoy} px.`,
  how_heard: 'A listener hears a hull when the distance between them is shorter than the reach. The reach is the range of the listener, times the noise of the hull, times the thermocline factor of their two depth bands.',
  how_noise: (p: { base: string | number; full: string | number }) => `The noise of a hull starts at the noise figure of its class. A still hull takes ×${p.base} of it, and a hull at full speed takes ×${p.full}.`,
  how_pick: 'the rules',
  how_quiet: (p: { cut: string | number; max: string | number; floor: string | number; damp: string | number; damp_floor: string | number }) => `A captain cuts the noise by ${p.cut} for each point of Quiet Hand, up to ${p.max} points, and never below ×${p.floor}. A Dampening module cuts it again (${p.damp} for tier I, II and III, times its roll), and never below ×${p.damp_floor}.`,
  how_range: (p: { tiers: string | number; roll_min: string | number; roll_max: string | number; ceiling: string | number }) => `A hull hears as far as the range of its class. A Sonar module adds a share of that range: ${p.tiers} for tier I, II and III, times its roll of ${p.roll_min} to ${p.roll_max}. The share of all modules stops at ${p.ceiling}.`,
  how_share: (p: { cls: string | number; share: string | number }) => `An ${p.cls} that shares its array hears ×${p.share} as far, for its whole faction.`,
  how_switches: (p: { silent: string | number; anchor: string | number; gun: string | number; launch: string | number; ping: string | number; crash: string | number; trench: string | number }) => `Silent Running gives a stopped hull ×${p.silent}. An anchor SET gives ×${p.anchor}. A gun echo gives ×${p.gun}, a launch echo ×${p.launch} and a ping echo ×${p.ping}. CRASH DIVE gives ×${p.crash}. A trench gives ×${p.trench}.`,
  how_typed: 'A typed system does not change sonar.',
  import_hint: 'add the presets of a file',
  key_column: 'hide or show the column',
  key_faster: 'speed the motion up by one step',
  key_fit: 'frame the units on the screen',
  key_motion: 'play or pause the motion of the hulls under way',
  key_remove: 'remove the picked unit',
  key_slower: 'slow the motion down by one step',
  kind_buoy: 'Hark',
  kind_hold: 'hold',
  kind_hull: 'hull',
  kind_installation: 'installation',
  kind_spire: 'Relay Spire',
  layer_baffles: 'baffles',
  layer_bands: 'thermocline',
  layer_field: 'heard field',
  layer_lines: 'contact lines',
  layer_patrols: 'patrols',
  layer_rings: 'reach ring',
  layer_tags: 'unit tags',
  legend_bands: 'depth bands · noise',
  legend_bands_off: 'depth bands · the flag depth is off',
  legend_field: 'heard by',
  lesson_next: 'NEXT',
  lesson_next_title: 'the next lesson',
  lesson_of: (p: { n: string | number; count: string | number }) => `lesson ${p.n} of ${p.count}`,
  lesson_prev: 'PREV',
  lesson_prev_title: 'the lesson before this one',
  lesson_try: 'try this',
  menu_file: 'presets',
  menu_run: 'motion',
  menu_view: 'view',
  motion_none_title: 'no hull is under way: set one under way in UNIT',
  none: 'none',
  notice_import_bad: (p: { file: string | number }) => `${p.file} is no preset file of the sonar lab`,
  notice_imported: (p: { count: number }) => plural(p.count, {
    one: `${p.count} preset imported`,
    other: `${p.count} presets imported`,
  }),
  notice_link: 'the link is on the clipboard',
  notice_loaded: (p: { name: string | number }) => `${p.name} loaded`,
  notice_no_name: 'type a name first',
  notice_saved: (p: { name: string | number }) => `saved ${p.name}`,
  notice_storage_refused: 'the browser refused the preset',
  pair_dist: (p: { dist: string | number; reach: string | number }) => `distance ${p.dist} px · reach ${p.reach} px`,
  pair_kind: 'contact',
  pair_name: (p: { src: string | number; tgt: string | number }) => `${p.src} → ${p.tgt}`,
  pause: 'PAUSE',
  pct: (p: { n: string | number }) => `${p.n} %`,
  play: 'PLAY',
  preset_delete: 'DELETE',
  preset_delete_sure: 'DELETE?',
  preset_export: 'EXPORT',
  preset_import: 'IMPORT',
  preset_load: 'LOAD',
  preset_name: 'name',
  preset_none: 'no preset yet',
  preset_save: 'SAVE',
  presets_pick: (p: { count: string | number }) => `${p.count} saved`,
  probe_is: 'WATCHED',
  probe_make: 'WATCH THIS HULL',
  probe_title: 'the heard field shows where this hull is heard',
  probe_word: 'watched',
  product: (p: { range: string | number; noise: string | number; thermo: string | number; reach: string | number }) => `${p.range} × ${p.noise} × ${p.thermo} = ${p.reach} px`,
  product_flat: (p: { range: string | number; noise: string | number; reach: string | number }) => `${p.range} × ${p.noise} = ${p.reach} px`,
  remove: 'REMOVE',
  remove_title: 'remove this unit',
  ring_inexact: 'A trench under the watched hull changes its noise, so the page draws no reach ring. The edge of the heard field shows the reach.',
  row_captain: 'captain',
  row_cell: 'field cell',
  row_cell_title: 'the grain of the heard field, in px: a smaller cell draws a finer edge and takes the engine more time',
  row_class: 'class',
  row_class_npc: 'NPC class',
  row_damp: 'Dampening',
  row_damp_roll: 'dampening roll',
  row_depth: 'depth',
  row_depth_title: 'the flag depth: the depth bands, their noise and the thermocline',
  row_faction: 'faction',
  row_module: 'Sonar module',
  row_module_roll: 'module roll',
  row_moving: 'under way',
  row_probe: 'watched hull',
  row_probe_title: 'the heard field shows where this hull is heard',
  row_quiet_hand: 'Quiet Hand',
  row_sapper: 'sapper',
  row_sapper_title: 'the flag sapper: a Hark hears only with it on',
  row_scene: 'lessons',
  row_seed: 'seed',
  row_size: 'map size',
  row_station: 'Sonar Station',
  row_typed: 'typed system',
  scene_baffles: 'Baffles',
  scene_deep_run: 'Fixed listeners against a deep run',
  scene_note_baffles: 'A listener under way, and a quiet hull that trails it in its rear arc, where the listener is almost deaf.',
  scene_note_deep_run: 'A hold and a Hark lose a hull on a deep run. The hull at sea still hears it.',
  scene_note_one_listener: 'A listener hears a hull of another faction when the hull is inside its reach. The solid line shows that the listener hears the watched hull.',
  scene_note_oracle_share: 'Two Oracles. One Oracle shares its array and hears twice as far.',
  scene_note_overview: 'Everything at once: a hold, an installation, a Relay Spire, a Hark and hulls of two factions, two of them under way.',
  scene_note_quiet_hand: 'Two equal hulls before one installation. One hull has a captain with ten points of Quiet Hand.',
  scene_note_thermocline: 'One listener on the shelf. The watched hull runs out to the deep water, and the reach steps down at each band edge.',
  scene_note_under_way: 'Two equal hulls stand at the same distance from the listener. The hull under way makes the noise of its speed, so the listener hears it. The still hull is quiet, and the listener does not hear it.',
  scene_one_listener: 'One listener',
  scene_oracle_share: 'Oracle SHARE',
  scene_overview: 'Overview',
  scene_quiet_hand: 'Quiet Hand',
  scene_thermocline: 'Thermocline',
  scene_try_baffles: 'Drag the quiet hull to the side of the listener, out of the rear arc.',
  scene_try_deep_run: 'Pick the hull on the deep run and turn deep run off in UNIT.',
  scene_try_one_listener: 'Drag the watched hull away from the listener until the line goes dashed.',
  scene_try_oracle_share: 'Pick the Oracle that shares and turn Oracle SHARE off in UNIT.',
  scene_try_overview: 'Pick a contact line to read why the listener hears the hull, or why it does not.',
  scene_try_quiet_hand: 'Pick the hull with the captain and set its Quiet Hand to 0 in UNIT.',
  scene_try_thermocline: 'Pick the listener and watch its reach ring step down at each band edge.',
  scene_try_under_way: 'Press PAUSE. Then drag the still hull nearer to the listener until its line goes solid.',
  scene_under_way: 'Under way',
  sheet_line: (p: { n: string | number; scene: string | number }) => `lesson ${p.n} · ${p.scene}`,
  speed_now: 'now',
  speed_step: (p: { step: string | number }) => `×${p.step}`,
  speed_title: 'the speed of the motion',
  status: (p: { units: string | number; heard: string | number; pairs: string | number }) => `${p.units} units · ${p.heard} of ${p.pairs} contacts heard`,
  still: 'still',
  storage_off: 'this browser keeps no preset, because the storage is off',
  tag_noise: (p: { value: string | number }) => `noise ×${p.value}`,
  tag_range: (p: { px: string | number }) => `hears ${p.px}`,
  term_anchor: 'anchor SET',
  term_buoy: 'Hark',
  term_class: 'class',
  term_crash_dive: 'CRASH DIVE',
  term_dampening: 'Dampening',
  term_echo: 'echo',
  term_installation: 'installation',
  term_module: 'Sonar module',
  term_quiet_hand: 'Quiet Hand',
  term_share: 'Oracle SHARE',
  term_silent_running: 'Silent Running',
  term_speed: 'speed',
  term_spire: 'Relay Spire',
  term_station: 'Sonar Station',
  term_terrain: 'depth and trench',
  thermo_caption: 'thermocline factor',
  thermo_corner: 'listener ↓ hull →',
  thermo_pair: (p: { from: string | number; to: string | number }) => `from the ${p.from} into the ${p.to}`,
  tiers: ['I', 'II', 'III', 'IV', 'V'],
  title: 'SONAR LAB',
  toggle_anchor: 'anchor SET',
  toggle_crash_dive: 'CRASH DIVE',
  toggle_deep_run: 'deep run',
  toggle_gun_echo: 'gun echo',
  toggle_launch_echo: 'launch echo',
  toggle_ping_echo: 'ping echo',
  toggle_share: 'Oracle SHARE',
  toggle_silent: 'Silent Running',
  toggle_title_anchor: 'the hull stands at anchor',
  toggle_title_crash_dive: 'the hull dives for a short time',
  toggle_title_deep_run: 'the hull runs deep: a fixed listener does not hear it',
  toggle_title_gun_echo: 'the hull has fired its guns a short time ago',
  toggle_title_launch_echo: 'the hull has launched a torpedo a short time ago',
  toggle_title_ping_echo: 'the hull has pinged a short time ago',
  toggle_title_share: 'the Oracle shares its array with its faction',
  toggle_title_silent: 'the hull has Silent Running researched',
  typed_no_sonar: 'A typed system does not change sonar.',
  under_way: 'under way',
  unit_name: (p: { id: string | number; what: string | number }) => `${p.id} · ${p.what}`,
  unit_none: 'Pick a unit on the map or in UNITS.',
  units_count: (p: { n: string | number; max: string | number }) => `${p.n} of ${p.max} units`,
  units_pick: (p: { n: string | number }) => `${p.n} units`,
  value_mul: (p: { mul: string | number }) => `×${p.mul}`,
  value_px: (p: { px: string | number }) => `${p.px} px`,
  verdict_deaf: (p: { cause: string | number }) => `NOT HEARD · ${p.cause}`,
  verdict_heard: 'HEARD',
  world_pick: (p: { seed: string | number; size: string | number }) => `seed ${p.seed} · ${p.size}`,
  zoom: (p: { pct: string | number }) => `${p.pct} %`,
  zoom_in: 'zoom in',
  zoom_out: 'zoom out',
  zoom_title: 'the zoom against a fit',
};

const squad_en: S.Squad = {
  changed_head: 'SQUAD CHANGED',
  changed_none: 'You fly in no squad now. No hull wears the squad mark.',
  changed_pickup: (p: { count: number }) => plural(p.count, {
    one: `You fly in a pickup squad now: ${p.count} commander, you alone. No other hull wears the squad mark.`,
    other: `You fly in a pickup squad now: ${p.count} commanders. The squad mark moved to their hulls and holds.`,
  }),
  changed_squad: (p: { count: number; n: string | number }) => plural(p.count, {
    one: `You fly in squad ${p.n} now: ${p.count} commander, you alone. No other hull wears the squad mark.`,
    other: `You fly in squad ${p.n} now: ${p.count} commanders. The squad mark moved to their hulls and holds.`,
  }),
  chip_pickup: 'PICKUP SQUAD',
  chip_squad: (p: { n: string | number }) => `SQUAD ${p.n}`,
  chip_title: 'Your squad: the commanders whose hulls and holds wear the squad mark. Press for the roster and the key of the marks.',
  faction_hold_no_mark: 'no mark',
  faction_hold_no_plate: 'no plate',
  key_count: (p: { count: number }) => plural(p.count, {
    one: `${p.count} commander`,
    other: `${p.count} commanders`,
  }),
  key_faction_hold: 'FACTION HOLD',
  key_foot: (p: { value: string | number; other: string | number }) => `Marks theme · ${p.value} · the ${p.other} value draws:`,
  key_head: 'MARKS',
  key_rest: 'the rest',
  key_squad_hold: 'SQUAD HOLD',
  key_you: 'YOU',
  key_your_fleets: 'your fleets',
  key_your_hold: 'YOUR HOLD',
  marks_key: 'MARKS KEY',
  open_clan: 'OPEN CLAN',
  own_hold_beam_column: 'a beam column',
  own_hold_breathing_lozenge: 'a breathing lozenge',
  own_hold_cross_rays: 'cross rays',
  own_hold_crown_chevrons: 'crown chevrons',
  own_hold_ground_plate: 'plate with a rim',
  own_hold_landing_pillars: 'landing pillars',
  pickup_body: (p: { count: number }) => plural(p.count, {
    one: `You have no clan, so the world put you in a squad for commanders who have none: ${p.count} commander so far, you. After the season, a squad mate who is a clan officer can invite you.`,
    other: `You have no clan, so the world put you in a squad of ${p.count} commanders who have none. Their hulls wear the squad mark. After the season, a squad mate who is a clan officer can invite you.`,
  }),
  pickup_head: 'PICKUP SQUAD',
  roster_at_sea: 'at sea',
  roster_online: 'online',
  roster_reserve: 'reserve',
  roster_you: 'you',
  squad_hold_half_plate: 'plate, no rim',
  squad_hold_no_mark: 'no mark',
  squad_hold_short_column: 'a short column',
  squad_hold_single_chevron: 'one chevron',
  squad_hold_small_lozenge: 'a small lozenge',
  squad_hold_waterline_ticks: 'waterline ticks',
};

const state_en: S.State = {
  cost_free: 'free',
  dur_days: (p: { days: string | number; hours: string | number }) => `${p.days}d ${p.hours}h`,
  dur_hours: (p: { hours: string | number; min: string | number }) => `${p.hours}h ${p.min}m`,
  dur_minutes: (p: { min: string | number; sec: string | number }) => `${p.min}m ${p.sec}s`,
  dur_seconds: (p: { sec: string | number }) => `${p.sec}s`,
  heat_activity_hi: 'busy',
  heat_activity_label: 'ACTIVITY',
  heat_activity_lo: 'quiet',
  heat_activity_season_hi: 'busy',
  heat_activity_season_label: 'ACTIVITY · SEASON',
  heat_activity_season_lo: 'quiet',
  heat_activity_season_what: 'commander work all season',
  heat_activity_what: 'commander work in the last hours',
  heat_beacon_hi: 'fast',
  heat_beacon_label: 'BEACON',
  heat_beacon_lo: 'none',
  heat_beacon_what: 'sov the anchored Beacons are taking',
  heat_currents_hi: 'fast',
  heat_currents_label: 'CURRENTS',
  heat_currents_lo: 'slack',
  heat_currents_what: 'the speed and the set of the current',
  heat_depth_hi: 'abyss',
  heat_depth_label: 'DEPTH',
  heat_depth_lo: 'shelf',
  heat_depth_what: 'the depth band of each cell',
  heat_kills_hi: 'many',
  heat_kills_label: 'KILLS',
  heat_kills_lo: 'none',
  heat_kills_season_hi: 'many',
  heat_kills_season_label: 'KILLS · SEASON',
  heat_kills_season_lo: 'none',
  heat_kills_season_what: 'fleets lost all season',
  heat_kills_what: 'fleets lost in the last hours',
  heat_off_label: 'OFF',
  heat_off_what: 'the plain map',
  heat_sov_hi: '5',
  heat_sov_label: 'SOV',
  heat_sov_lo: '0',
  heat_sov_what: 'how strongly each owned cell is held',
  heat_stability_hi: 'just flipped',
  heat_stability_label: 'STABILITY',
  heat_stability_lo: 'settled',
  heat_stability_what: 'how recently the cell changed hands',
  mission_names: ['—', 'Move', 'Gather', 'Patrol', 'Hold', 'Hauling', 'Returning', 'Capturing', 'Escorting', 'Hunting', 'Anchored', 'Steering', 'Searching'],
  num_millions: (p: { n: string | number }) => `${p.n}M`,
  num_thousands: (p: { n: string | number }) => `${p.n}k`,
};

const symbols_en: S.Symbols = {
  back: '← THEME WORKSHOP',
  col_hull: 'hull',
  col_kind: 'kind',
  col_role: 'role',
  col_says: 'what the mark says',
  col_weight: 'weight',
  desc_arcs: 'An arc is a piece of a circle. Artillery carries an arc ahead of the bow, the range fan, and the siege gun carries two. A brawler carries an arc astern, a close guard wrapped round the stern. The skirmisher carries two small arcs at the beam, fins. The torpedo boat carries two small arcs ahead, the mouths of its tubes. Each support hull draws its arcs thinner: a ring open at the bow for the Sentinel, one arc astern for the Vedette, two arcs ahead for the Oracle, a full ring for the Tender, three arcs for the Beacon and a cup for the Dredger. Under the hollow master every arc becomes two thin lines and holds.',
  desc_arrows: 'Everything on the water is an arrow. A brawler carries two small darts at its stern beam that point forward, its escorts. Artillery pushes a small dart ahead on the axis, the shell. The skirmisher trails one small dart that points back, the ghost of where it was. The torpedo boat carries two small darts ahead, the torpedoes. Each support hull uses a mini needle: two that point outward for the Sentinel, one reversed for the Vedette, one ahead for the Oracle, one alongside for the Tender, three that radiate for the Beacon and one in tow for the Dredger. One shape makes every mark. Weak point: at the smallest zoom a mini dart astern looks like a second ship behind the first.',
  desc_by_name: 'The Corsair carries a grapnel on a line astern. The Cutlass is the blade, with a crossguard, a grip and a pommel. The Falconet has a short barrel and the two wheels of a carriage gun. The Basilisk has the long barrel and the zigzag tail of a serpent. The Bombard carries a mortar bowl astern. The Lancer has a long lance with a pennon. The Sentinel has a keep astern, the Vedette a pennant, the Oracle an eye ahead of the bow and the Dredger a scoop on a short tow. The Tender keeps its lifebuoy and the Beacon its radial. Two hulls of one role look alike only where the name allows it: the two guns share a barrel, and the two brawlers share nothing. Under the hollow master the pommel, the wheels and the pupil become rings.',
  desc_chevrons: 'A chevron is two bars that meet at a point, the rank mark of every navy. A brawler stacks chevrons astern that point forward, the drive that pushes it in. Artillery stacks them ahead of the bow, the shell going out. The skirmisher trails one chevron that points back. The torpedo boat carries two small chevrons at the beam. The count is the weight. Each support hull carries one thin chevron in a shape of its own: an A-frame for the Sentinel, a small back chevron for the Vedette, a V at the bow for the Oracle, a brace for the Tender, a burst for the Beacon and a closed triangle on a tow for the Dredger. The hollow master holds, because a chevron is already two lines.',
  desc_default: 'This is the set the game ships. A combat hull wears one swept wing on each side. The sweep of the wing says how the ship fights, and the span of the wing says how heavy it is. Each support hull wears a thin ornament that names its trade: two swept bars for the Sentinel, a quill for the Vedette, two arcs for the Oracle, a ring for the Tender, a radial for the Beacon and a tow of crates for the Dredger. Weak point: the two detached bars of the Sentinel look much like a swept wing.',
  desc_filigree: 'The combat row drops to the thin line of the support row. The Corsair carries two hairline streaks astern. The Cutlass carries two pairs of hairline stubs at the bow. The Falconet carries a hairline barrel with one tick, and the Basilisk a longer barrel with two. The Bombard carries a hairline barrel and a hairline ring ahead, the splash. The Lancer carries a stub and three dots ahead, the track. The support row is the shipped one. This is the lightest set, and the dart under the hairlines carries the difference between the two rows alone. Weak point: at the smallest zoom a hairline is gone and the combat row is plain darts.',
  desc_insignia: 'The quietest set. The Corsair carries one slash astern and the Cutlass an X. The Falconet carries one bar ahead of the bow and the Basilisk two. The Bombard carries a solid disc astern. The Lancer carries a line that ends in a dot. The Sentinel carries a hollow square, the Vedette one hairline, the Oracle a dot in a ring, the Tender a cross, the Beacon an asterisk and the Dredger a solid square. The kinship is in the position: a gun carries its mark ahead of the bow, and every other hull carries it astern. You learn the set in a minute, but no mark tells you what the hull does before you learn it. Under the hollow master the disc and the square become a ring and a box, and the pupil of the Oracle is lost.',
  desc_pips: 'A pip is one solid dot. A brawler carries pairs of pips at the bow beam, the knuckles of a fist. Artillery carries pips in a line ahead of the bow, the shell in flight. The skirmisher trails one pip astern, a wake. The torpedo boat carries two pips ahead, its tubes. Each support hull uses a smaller pip: three astern for the Sentinel, one for the Vedette, three in an arc for the Oracle, four in a ring for the Tender, five in a radial for the Beacon and two in a tow line for the Dredger. The set reads best at the smallest zoom. Weak point: under the hollow master each pip becomes a small ring, and the small support pips blur together.',
  desc_plates: 'A plate is a flat piece beside the hull. One rule runs the whole roster: a combat hull carries its plate solid, and a support hull carries its plate as an outline. A brawler wears square armour at the beam. Artillery wears long thin plates beside the bow, the barrels. The skirmisher wears two small fins at the stern. The torpedo boat wears two plates shaped like a bullet. The size of the plate is the weight. Weak point: under the hollow master a combat plate becomes a box, which is what the support row already is, so the two rows stand closer.',
  desc_rungs: 'A rung is one bar across the hull. A brawler carries square rungs at the bow, because it closes with the enemy. Artillery carries square rungs astern, because it stands off. The skirmisher has one rung swept back, and the torpedo boat has rungs swept forward. The count of the rungs is the weight: one, two or three. Each support hull carries one thin rung with a tip that names its trade. Under the hollow master a rung becomes a thin box, and the count still reads.',
  desc_tails: 'The bow is the base and the tail is the class. A brawler ends in a blunt block astern. Artillery trails a long thin tail, the recoil, and the siege gun ends it with a breech bar. The skirmisher has a forked tail, a fish. The torpedo boat trails twin tails, its tubes. Each support hull trails a thin tail: a T for the Sentinel, a short V for the Vedette, a line of pings for the Oracle, a loop for the Tender, a fan for the Beacon and a crate on a tow for the Dredger. Every mark is longest astern, so the bow stays the clearest point and you read the heading from the tail too. Under the hollow master the pings of the Oracle become rings.',
  desc_teeth: 'A tooth is a small triangle on the flank of the hull, so the outline is serrated. A brawler wears teeth swept back from the bow. Artillery wears square teeth. The skirmisher wears one pair swept far back. The torpedo boat wears teeth swept forward. The count is one, two or three pairs. Each support hull wears tiny teeth in a shape of its own: battlements for the Sentinel, one swept pair for the Vedette, a V for the Oracle, a dock for the Tender, a star for the Beacon and a rake for the Dredger. The set is busiest at the largest zoom and calmest at the smallest, where the teeth fuse into a wider hull. Under the hollow master the teeth become open notches and the count still reads.',
  form_desk: 'DESKTOP',
  form_phone: 'TELEPHONE',
  grammar: 'grammar',
  grammar_arcs: 'the role is which way the arc faces · the weight is the radius and the count · a support hull draws its arcs thinner',
  grammar_arrows: 'the role is where the small arrow sits and which way it points · the weight is its size and count · a support hull wears mini needles',
  grammar_by_name: 'each hull draws the thing it is named after',
  grammar_chevrons: 'the role is where the chevron sits and which way it points · the weight is the count · a support hull wears one thin chevron',
  grammar_default: 'the role is the sweep of the wing · the weight is the span of the wing · a support hull wears a thin ornament',
  grammar_filigree: 'every extra is a hairline, and the dart alone carries the weight',
  grammar_insignia: 'each hull carries one small mark of the fewest lines',
  grammar_pips: 'the role is where the pips sit · the weight is the count of the pips · a support hull wears smaller pips',
  grammar_plates: 'the role is the shape of the plate beside the hull · the weight is the size of the plate · a support hull wears the same plate as an outline',
  grammar_rungs: 'the role is where the rung sits and how it sweeps · the weight is the count of the rungs · a support hull wears one thin rung',
  grammar_tails: 'the role is the shape of the tail · the weight is the length of the tail · a support hull wears a thin tail',
  grammar_teeth: 'the role is the sweep of the teeth on the flank · the weight is the count of the teeth · a support hull wears tiny teeth',
  ink_colour: 'COLOUR',
  ink_grey: 'GREYSCALE',
  kind_combat: 'combat',
  kind_support: 'support',
  lede: 'A ship icon set is the look of every ship on the map. The SHIP ICON row of the theme workshop picks one set for every hull. A PER HULL row gives one hull a set of its own. This page shows every set on every hull.',
  master_fill: 'FILLED',
  master_hollow: 'HOLLOW',
  role_artillery: 'artillery',
  role_brawler: 'brawler',
  role_cargo: 'cargo',
  role_command: 'command',
  role_engineer: 'engineer',
  role_repair: 'repair',
  role_scout: 'scout',
  role_skirmish: 'skirmish',
  role_sonar: 'sonar',
  role_sovereignty: 'sovereignty',
  role_torpedo: 'torpedo',
  role_tower: 'tower',
  rules_bases: 'Two shapes carry the whole roster. Every combat mark is one dart plus extras. Every support mark is one thin needle plus extras. A set states the extras alone, so no set can break the rule.',
  rules_title: 'THE RULES EVERY SET KEEPS',
  rules_weight: 'A combat mark says the role and the weight. The role is the way the ship fights. The weight has three steps: light, medium and heavy. Every support mark is thin. The MASTER switch shows the two ways the game paints a mark. It fills the shape for most hulls and strokes it for a squadmate, so a dot becomes a small ring and a solid block becomes a box. A set that loses a detail that way says so.',
  says_basilisk: 'the siege gun',
  says_beacon: 'it plants and broadcasts; territory moves because of it',
  says_bombard: 'the heaviest hull',
  says_commodore: 'the one flagship; it leads the own hulls round it',
  says_corsair: 'the fast quiet hunter',
  says_cutlass: 'the cheap fist, the free hull',
  says_dredger: 'the hauler',
  says_falconet: 'the cheap gun',
  says_lancer: 'the striker; three tube kinds',
  says_oracle: 'the ear; it shares what it hears',
  says_sapper: 'the engineer; it lays sea mines and deployables and takes them back aboard',
  says_sentinel: 'the one support hull that shoots; it plants and holds a lane',
  says_tender: 'it mends the hull beside it; set, it is a berth',
  says_vedette: 'the eyes; the quietest hull',
  sw_form: 'form',
  sw_ink: 'ink',
  sw_master: 'master',
  sw_view: 'view',
  sw_zoom: 'zoom',
  title: 'SHIP SYMBOLS',
  view_sets: 'BY SET',
  view_ships: 'BY SHIP',
  weight_heavy: 'heavy',
  weight_light: 'light',
  weight_medium: 'medium',
  weight_thin: 'thin',
  zoom_half: '0.5×',
  zoom_one: '1×',
  zoom_two: '2×',
};

const terrainlab_en: S.Terrainlab = {
  apron_value: 'of a strategic object',
  cache_value: (p: { id: string | number }) => `seeded cache ${p.id}`,
  card_anchor: 'Anchor',
  card_cache: (p: { id: string | number }) => `Seeded cache ${p.id}`,
  card_cell: (p: { cell: string | number }) => `Cell ${p.cell}`,
  card_den: (p: { id: string | number }) => `Den ${p.id}`,
  card_deposit: (p: { resource: string | number }) => `${p.resource} deposit`,
  card_hold: (p: { pocket: string | number }) => `Hold of pocket ${p.pocket}`,
  card_lair: (p: { id: string | number }) => `Lair ${p.id}`,
  card_note: 'A tap on a cell picks it. The pick stays when the seed moves, so A and B show the same cell.',
  card_pocket: (p: { pocket: string | number }) => `Squad pocket ${p.pocket}`,
  card_point: (p: { kind: string | number; id: string | number }) => `${p.kind} ${p.id}`,
  card_seamount: (p: { id: string | number }) => `Seamount ${p.id}`,
  cell_place: (p: { cell: string | number; col: string | number; row: string | number }) => `${p.cell} · col ${p.col} · row ${p.row}`,
  cells_chip: (p: { cells: string | number }) => `${p.cells} cells`,
  copy_ab: 'A → B',
  copy_ab_hint: 'copy A into B',
  copy_ab_title: 'copy the generators and the values of A into B',
  copy_link: 'COPY LINK',
  default_value: (p: { value: string | number }) => `default ${p.value}`,
  dice_title: 'a random seed',
  editing: (p: { side: string | number }) => `editing side ${p.side}`,
  export_hint: 'all, as one file',
  fact_ambush: 'AMBUSH WATER',
  fact_amount: 'AMOUNT',
  fact_apron: 'APRON',
  fact_body: 'TRENCH BODY',
  fact_brotherhood: 'BROTHERHOOD',
  fact_buoy: 'BUOY',
  fact_cache: 'CACHE',
  fact_cell: 'CELL',
  fact_design: 'DESIGN',
  fact_faction: 'FACTION',
  fact_fairway: 'FAIRWAY',
  fact_holds: 'HOLDS',
  fact_hunt: 'HUNTING WATER',
  fact_monster: 'MONSTER',
  fact_moved: 'DEN',
  fact_owner: 'TERRITORY',
  fact_pirate_cache: 'PIRATE CACHE',
  fact_quiet: 'QUIET',
  fact_seamount: 'SEAMOUNT',
  fact_sortie: 'SORTIE WATER',
  fact_terrain: 'TERRAIN',
  fact_window: 'WINDOW',
  failed: (p: { side: string | number; error: string | number }) => `side ${p.side}: the generation failed: ${p.error}`,
  fairway_value: (p: { index: string | number }) => `chain ${p.index}`,
  fit: 'FIT',
  hunt_value: (p: { brotherhood: string | number; id: string | number }) => `${p.brotherhood} den ${p.id}`,
  hunt_value_own: (p: { brotherhood: string | number; id: string | number }) => `${p.brotherhood} den ${p.id} · a target here comes first`,
  import_hint: 'add a file',
  key_dice: 'a random seed',
  key_fit: 'fit the map to the screen',
  key_next: 'the seed after',
  key_panel: 'open or close the panel',
  key_prev: 'the seed before',
  key_split: 'show A and B side by side',
  key_swap: 'edit and show the other side',
  keys: 'keys',
  kind_anchor: 'FACTION ANCHOR',
  kind_cache: 'SEEDED CACHE',
  kind_cell: 'CELL',
  kind_den: 'PIRATE DEN',
  kind_den_quiet: 'PIRATE DEN · QUIET',
  kind_deposit: 'DEPOSIT',
  kind_hold: 'HOLD',
  kind_hold_fallback: 'HOLD · NO FLOOR, TOOK THE CELL UNDER THE CENTRE',
  kind_installation: 'FACTION INSTALLATION',
  kind_lair: 'MONSTER LAIR',
  kind_object: 'STRATEGIC OBJECT',
  kind_pocket: 'SQUAD POCKET',
  kind_pocket_fallback: 'SQUAD POCKET · FELL BACK ONTO THE ANCHOR',
  kind_pocket_installation: 'SQUAD POCKET · ON AN INSTALLATION',
  kind_pocket_middle: 'SQUAD POCKET · MIDDLE BAND',
  kind_point: 'POINT OF INTEREST',
  kind_seamount: 'SEAMOUNT',
  layer_anchors: 'anchors',
  layer_buoys: 'buoys',
  layer_caches: 'caches',
  layer_dens: 'pirate dens',
  layer_fairways: 'fairways',
  layer_grid: 'hex grid',
  layer_holds: 'holds',
  layer_hunt: 'hunting and sortie water',
  layer_installations: 'faction installations',
  layer_lairs: 'monster lairs',
  layer_objects: 'strategic objects',
  layer_pockets: 'squad pockets',
  layer_points: 'vents and current gates',
  layer_quiet: 'quiet dens',
  layer_ranges: 'monster ranges',
  layer_seamounts: 'seamounts',
  layer_sites: 'deposits',
  layer_territory: 'territory',
  menu_lab: 'THIS LAB',
  menu_presets: 'PRESETS',
  moved_value: (p: { id: string | number; cell: string | number }) => `den ${p.id} moves here from cell ${p.cell}`,
  ms: (p: { ms: string | number }) => `${p.ms} ms`,
  name: 'Terrain lab',
  next_title: 'the seed after',
  no_generator: 'this generation slot has no generator',
  none: 'none',
  notice_import_bad: (p: { file: string | number }) => `${p.file} is no preset file of the terrain lab`,
  notice_imported: (p: { count: number }) => plural(p.count, {
    one: `${p.count} preset imported`,
    other: `${p.count} presets imported`,
  }),
  notice_link: 'the link is on the clipboard',
  notice_loaded: (p: { name: string | number; side: string | number }) => `${p.name} loaded into side ${p.side}`,
  notice_no_name: 'type a name first',
  notice_saved: (p: { name: string | number }) => `saved ${p.name}`,
  notice_storage_refused: 'the browser refused the preset',
  overlay: 'cell field',
  overlay_height: 'height',
  panel: 'PANEL',
  panel_hint: 'the column',
  panel_title: 'open or close the panel',
  pirate_cache_value: (p: { id: string | number; x: string | number; y: string | number }) => `den ${p.id} · x ${p.x} · y ${p.y}`,
  pirates: 'PIRATES',
  pirates_off: 'off',
  pirates_on: 'on',
  pirates_title: 'the flag pirates: on, a lair has a monster kind and a den a brotherhood, and the dens think',
  preset_delete: 'DELETE',
  preset_delete_sure: 'DELETE?',
  preset_export: 'EXPORT',
  preset_import: 'IMPORT',
  preset_load: 'LOAD',
  preset_load_title: (p: { side: string | number }) => `load this preset into side ${p.side}; the seed stays`,
  preset_name: 'name',
  preset_none: 'no preset yet',
  preset_save: (p: { side: string | number }) => `SAVE ${p.side}`,
  preset_save_title: (p: { side: string | number }) => `save the generators and the values of side ${p.side} under this name`,
  preset_seed: (p: { seed: string | number; seats: string | number }) => `seed ${p.seed} · ${p.seats}`,
  preset_seed_title: 'use the seed and the size this preset was saved at',
  presets: 'presets',
  presets_pick: (p: { count: number }) => plural(p.count, {
    one: `${p.count} saved · in this browser`,
    other: `${p.count} saved · in this browser`,
  }),
  prev_title: 'the seed before',
  quiet_stays: (p: { rings: string | number }) => `no free cell inside ${p.rings} rings; stays quiet`,
  quiet_to: (p: { cell: string | number }) => `moves to cell ${p.cell}`,
  range_value: (p: { id: string | number; kind: string | number }) => `lair ${p.id} · ${p.kind}`,
  roll: 'roll seed',
  roll_bad: 'a roll seed is empty or a whole number from -9223372036854775808 to 9223372036854775807',
  roll_dice_title: 'a random roll seed',
  roll_empty: '= seed',
  roll_title: 'the roll seed of the points of interest, the dens and the NPC draws; empty takes the seed',
  seamount_value: (p: { id: string | number; cells: string | number }) => `seamount ${p.id} · ${p.cells} cells`,
  seed: 'seed',
  seed_bad: 'a seed is a whole number from -9223372036854775808 to 9223372036854775807',
  side_a: 'A',
  side_b: 'B',
  side_title: (p: { side: string | number }) => `edit and show side ${p.side}`,
  size: 'size',
  size_row: (p: { seats: string | number; cols: string | number; rows: string | number }) => `${p.seats} seats · ${p.cols} × ${p.rows}`,
  slot_cleanup: 'cleanup',
  slot_fairways: 'fairways',
  slot_placement: 'placement',
  slot_sites: 'sites',
  slot_terrain: 'terrain',
  sortie_value: (p: { brotherhood: string | number; id: string | number; every: string | number }) => `${p.brotherhood} den ${p.id} · one roam leg in ${p.every}`,
  split: 'SPLIT',
  split_title: 'show A and B side by side, on one seed',
  stats: 'stats',
  stats_ab: 'A against B',
  stats_pick: (p: { ms: string | number }) => `${p.ms} ms`,
  status_cells: (p: { cells: string | number }) => `${p.cells} cells`,
  status_failed: (p: { side: string | number }) => `${p.side} failed`,
  status_fallbacks: (p: { count: number; side: string | number }) => plural(p.count, {
    one: `${p.side} ${p.count} fallback`,
    other: `${p.side} ${p.count} fallbacks`,
  }),
  storage_off: 'this browser keeps no preset, because the storage is off',
  terrain_height: (p: { terrain: string | number; height: string | number }) => `${p.terrain} · height ${p.height}`,
  timings: 'time',
  tip_ambush: (p: { id: string | number; kind: string | number }) => `ambush water of lair ${p.id} · ${p.kind}`,
  tip_anchor: (p: { faction: string | number }) => `anchor · ${p.faction}`,
  tip_apron: 'apron of a strategic object',
  tip_body: (p: { id: string | number; kind: string | number }) => `trench body of lair ${p.id} · ${p.kind}`,
  tip_buoy: (p: { kind: string | number }) => `buoy · ${p.kind}`,
  tip_cache: (p: { id: string | number }) => `seeded cache ${p.id}`,
  tip_cell: (p: { cell: string | number; col: string | number; row: string | number }) => `cell ${p.cell} · col ${p.col} · row ${p.row}`,
  tip_den: (p: { id: string | number; brotherhood: string | number; design: string | number }) => `den ${p.id} · ${p.brotherhood} · ${p.design}`,
  tip_den_moved: (p: { id: string | number; cell: string | number }) => `den ${p.id} moves here from cell ${p.cell}`,
  tip_den_plain: (p: { id: string | number }) => `den ${p.id}`,
  tip_den_quiet: (p: { id: string | number; cell: string | number }) => `den ${p.id} is quiet · moves to cell ${p.cell}`,
  tip_den_stays: (p: { id: string | number }) => `den ${p.id} is quiet · no free cell, stays quiet`,
  tip_deposit: (p: { resource: string | number; amount: string | number }) => `deposit · ${p.resource} · ${p.amount}`,
  tip_fairway: (p: { index: string | number }) => `fairway chain ${p.index}`,
  tip_hold: (p: { faction: string | number; pocket: string | number }) => `hold · ${p.faction} · squad pocket ${p.pocket}`,
  tip_hold_fallback: (p: { faction: string | number; pocket: string | number }) => `hold · ${p.faction} · squad pocket ${p.pocket} · no floor, took the cell under the centre`,
  tip_hunt: (p: { brotherhood: string | number; id: string | number }) => `hunting water of ${p.brotherhood} den ${p.id}`,
  tip_hunt_own: (p: { brotherhood: string | number; id: string | number }) => `hunting water of ${p.brotherhood} den ${p.id} · a target here comes first`,
  tip_installation: (p: { name: string | number; faction: string | number }) => `faction installation · ${p.name} · ${p.faction}`,
  tip_lair: (p: { id: string | number; kind: string | number; design: string | number }) => `lair ${p.id} · ${p.kind} · ${p.design}`,
  tip_lair_plain: (p: { id: string | number }) => `lair ${p.id}`,
  tip_object: (p: { name: string | number; window: string | number }) => `strategic object · ${p.name} · window ${p.window}`,
  tip_owner: (p: { faction: string | number }) => `territory · ${p.faction}`,
  tip_pirate_cache: (p: { id: string | number }) => `pirate cache of den ${p.id}`,
  tip_pocket: (p: { pocket: string | number; faction: string | number; members: string | number }) => `squad pocket ${p.pocket} · ${p.faction} · ${p.members} holds`,
  tip_pocket_fallback: (p: { pocket: string | number; faction: string | number }) => `squad pocket ${p.pocket} · ${p.faction} · fell back onto the anchor`,
  tip_pocket_installation: (p: { pocket: string | number; faction: string | number }) => `squad pocket ${p.pocket} · ${p.faction} · on an installation`,
  tip_pocket_middle: (p: { pocket: string | number; faction: string | number }) => `squad pocket ${p.pocket} · ${p.faction} · middle band`,
  tip_point: (p: { id: string | number; kind: string | number }) => `point of interest ${p.id} · ${p.kind}`,
  tip_ridge: 'ridge',
  tip_seamount: (p: { id: string | number; cells: string | number }) => `seamount ${p.id} · ${p.cells} cells`,
  tip_sortie: (p: { brotherhood: string | number; id: string | number }) => `sortie water of ${p.brotherhood} den ${p.id}`,
  tip_trench: 'trench',
  tip_value: (p: { name: string | number; value: string | number }) => `${p.name} ${p.value}`,
  tip_water: 'water',
  total: 'total',
};

const timelapse_en: S.Timelapse = {
  band: 'TIMELAPSE',
  legend_commander: (p: { commander: string | number }) => `The faction of ${p.commander}`,
  legend_head: 'CELLS HELD AT THE FRAME',
  legend_mine: 'Your faction',
  live: 'LIVE',
  on_the_map: '▸ ON THE MAP',
  pause: 'Pause',
  play: 'Play',
  reader_frames: (p: { frames: number }) => plural(p.frames, {
    one: `${p.frames} FRAME`,
    other: `${p.frames} FRAMES`,
  }),
  reader_head: (p: { from: string | number; to: string | number }) => `THE SEA · DAY ${p.from} TO DAY ${p.to}`,
  scrub: 'The frame',
  sea_none: 'NO PUBLIC MAP OF THIS SEASON',
  sea_none_why: 'THE SEASON STILL RUNS, OR THE ADDRESS IS WRONG.',
  sea_page: 'THE SEA',
  sea_season: (p: { season: string | number }) => `SEASON ${p.season} · CLOSED`,
  sea_title: (p: { world: string | number }) => `THE SEA OF ${p.world}`,
  sea_what: 'THE TERRITORY MAP OF A CLOSED SEASON: WHICH FACTION HELD EACH CELL, FROM THE FIRST DAY TO THE LAST. IT SHOWS NO FLEET AND NO PLAYER.',
  series_tag: 'TIMELAPSE',
  speed: (p: { n: string | number }) => `×${p.n}`,
  speed_title: 'The speed',
  stamp: (p: { day: string | number; time: string | number }) => `DAY ${p.day} · ${p.time}`,
  stamp_now: (p: { day: string | number }) => `NOW · DAY ${p.day}`,
  summary_every: (p: { hours: number }) => plural(p.hours, {
    one: `ONE FRAME EVERY ${p.hours} HOUR`,
    other: `ONE FRAME EVERY ${p.hours} HOURS`,
  }),
  summary_head: (p: { frames: number }) => plural(p.frames, {
    one: `THE SEASON · ${p.frames} FRAME`,
    other: `THE SEASON · ${p.frames} FRAMES`,
  }),
  tick_day: (p: { day: string | number }) => `DAY ${p.day}`,
  tick_now: 'NOW',
  war_head: (p: { stamp: string | number }) => `Sovereignty · ${p.stamp}`,
  war_note: 'Drag the frame or press play: the map shows who held each cell at that time. Drag to NOW for the live map.',
};

const touchLog_en: S.TouchLog = {
  chip: (p: { count: string | number }) => `TOUCH LOG · ${p.count}`,
  clear: 'CLEAR',
  copied: 'COPIED',
  copy: 'COPY',
  select_and_copy: 'SELECT THE TEXT AND COPY IT',
  share: 'SHARE',
};

const trials_en: S.Trials = {
  closing_head: 'SEA TRIALS COMPLETE',
  closing_long: 'Next: take cells with your Beacons. Each cell they take adds to your season score.',
  closing_short: (p: { done: string | number; total: string | number }) => `${p.done} / ${p.total}`,
  drill: 'learn the controls in a drill. Fleets, sonar and fights work as in conquest, and a drill uses no arcade run.',
  drill_go: 'START',
  drill_tag: 'DRILL',
  drill_title: 'Opens the drill in the arcade',
  fold: 'Fold the sea trials to one line',
  label: (p: { done: string | number; total: string | number }) => `TRIALS ${p.done}/${p.total}`,
  next: (p: { step: string | number }) => `${p.step}.`,
  show: 'SHOW',
  show_title: (p: { panel: string | number }) => `Opens ${p.panel} and gives no order`,
  step_build_beacon: 'Build a Beacon',
  step_build_dredger: 'Build a Dredger',
  step_launch_fleet: 'Deploy a fleet',
  step_queue_building: 'Build a building',
  step_recruit_captain: 'Recruit a captain',
  step_send_gather: 'Send a fleet to gather',
  step_start_research: 'Decrypt a tech research node',
  step_take_cell: 'Take a cell',
  title: 'Open the panel of the next act. The sea trials give no order.',
  unfold: 'Show the eight acts',
};

const viewpanel_en: S.Viewpanel = {
  back: 'back to VIEW',
  chart_aside: 'the reading of the furniture',
  chart_head: 'CHART',
  chat: 'CHAT',
  group_currents: 'CURRENTS',
  group_depth: 'DEPTH',
  group_tracks: 'TRACKS',
  group_wrecks: 'WRECKS',
  head: 'VIEW',
  head_sub: 'what stands over the map',
  heat: 'HEAT',
  heat_aside_touch: 'one press per mode',
  heat_none_what: 'No mode paints.',
  heat_off: 'OFF',
  heat_paints: (p: { mode: string | number }) => `${p.mode} paints`,
  heat_row: (p: { mode: string | number }) => `HEAT · ${p.mode}`,
  home: 'GO TO THE HOLD',
  key: 'FACTION KEY',
  layers: 'LAYERS',
  legend: 'LEGEND',
  map: 'MINIMAP',
  off: 'OFF',
  on: 'ON',
  pieces_head: 'CHART PIECES',
  reading_historical: 'HISTORICAL',
  reading_modern: 'MODERN',
  reading_off: 'OFF',
  rose_peek: 'HOME',
  rose_title: 'centre the map on your hold',
  scale_cells: (p: { n: number }) => plural(p.n, {
    one: `${p.n} cell`,
    other: `${p.n} cells`,
  }),
  sea: 'SEA VIEW HERE',
  sea_follow: 'FOLLOW IN THE SEA VIEW',
  unread: (p: { n: number }) => plural(p.n, {
    one: `${p.n} unread chat line`,
    other: `${p.n} unread chat lines`,
  }),
  view: 'VIEW',
  view_title: 'what stands over the map · hold for the quick wheel',
};

const warcharts_en: S.Warcharts = {
  unclaimed: 'Unclaimed',
};

const welcome_en: S.Welcome = {
  built: 'WHAT THE AUTOPILOT BUILT',
  built_buildings: (p: { n: number }) => plural(p.n, {
    one: `${p.n} BUILDING`,
    other: `${p.n} BUILDINGS`,
  }),
  built_captains: (p: { n: number }) => plural(p.n, {
    one: `${p.n} CAPTAIN`,
    other: `${p.n} CAPTAINS`,
  }),
  built_fleets: (p: { n: number }) => plural(p.n, {
    one: `${p.n} FLEET`,
    other: `${p.n} FLEETS`,
  }),
  captain_ashore: 'ashore',
  command: (p: { hold: string | number }) => `You command one empire: the hold ${p.hold}, its buildings, its fleets and its captains.`,
  dir_e: 'east',
  dir_n: 'north',
  dir_ne: 'north-east',
  dir_nw: 'north-west',
  dir_s: 'south',
  dir_se: 'south-east',
  dir_sw: 'south-west',
  dir_w: 'west',
  find_clan: 'FIND A CLAN',
  find_clan_title: 'Opens CLAN · FIND A CLAN of the hub in a new tab',
  fleet_pens: (p: { cls: string | number }) => `${p.cls} · pens`,
  go: 'TAKE COMMAND',
  handover: 'The autopilot held your empire since the season began. It stands down now.',
  head_buildings: 'BUILDINGS',
  head_captains: 'CAPTAINS',
  head_fleets: 'FLEETS',
  head_neighbours: 'NEIGHBOURS',
  head_research: 'RESEARCH',
  head_season: 'THE SEASON',
  heading: 'YOU TAKE COMMAND',
  how: 'HOW IT PLAYS',
  kicker: (p: { season: string | number; day: string | number; faction: string | number }) => `SEASON ${p.season} · DAY ${p.day} · ${p.faction}`,
  level: (p: { level: string | number }) => `level ${p.level}`,
  neighbour: (p: { faction: string | number; dir: string | number }) => `${p.faction} · ${p.dir}`,
  neighbour_own: (p: { dir: string | number }) => `your faction · ${p.dir}`,
  research_done: 'done',
  research_queued: 'in the queue',
  season_clan: (p: { members: string | number }) => `A clan of up to ${p.members} commanders keeps you together after this season.`,
  season_goal: (p: { days: string | number }) => `Goal: grow your season score. Each cell your Beacons take, each hostile fleet you sink and each siege you win adds points. When the ${p.days}-day season ends, the score becomes Honour.`,
  season_stays: 'What stays: your captains, your Honour and your name. Everything else ends at the seaquake.',
  season_team: 'You play with your squad and your faction. They share the ground, the chat and the fight for the strategic objects.',
  squad: (p: { squad: string | number; clan: string | number }) => `You fly in squad ${p.squad} of the ${p.clan}.`,
  threat: (p: { hold: string | number; faction: string | number; dir: string | number }) => `The nearest hostile hold is ${p.hold}, ${p.faction}, to the ${p.dir}.`,
  threat_time: (p: { fleet: string | number; time: string | number }) => `${p.fleet}, your fastest fleet, needs about ${p.time} to reach it.`,
  trials: 'SEA TRIALS',
  truce: (p: { left: string | number }) => `Founding truce: nobody can attack you for ${p.left}.`,
  truce_over: 'The founding truce is over. A hostile fleet can attack you now.',
  where_advisor: 'The ADVISOR line names one good next step. A press opens the panel. You give the order.',
  where_key: 'The faction colours: VIEW · LEGEND.',
  where_support: 'Questions: ☸ OPTIONS · MENU · HELP.',
};

const workshop_en: S.Workshop = {
  activated: (p: { code: string | number }) => `CODE ${p.code} IS ACTIVE`,
  add: '+ ADD',
  alpha_edge: 'EDGE ALPHA',
  alpha_panel: 'PANEL ALPHA',
  back_hub: '← HUB',
  bank: 'THE BANK',
  cancel: 'CANCEL',
  chart_changed: 'A switch with a gold edge differs from the build.',
  chart_lede: 'A Chart theme turns a piece on or off in one reading. The theme stores only the switches that differ from the build.',
  chart_pack: (p: { historical: string | number; modern: string | number }) => `BUILD ${p.historical} · ${p.modern}`,
  chart_reading: 'PREVIEW READING',
  chart_switch: (p: { reading: string | number; value: string | number }) => `${p.reading} ${p.value}`,
  chk_contrast: (p: { ratio: string | number; floor: string | number }) => `Text on the panel reads ${p.ratio} : 1, below the floor of ${p.floor} : 1. Make the text lighter or the panel darker.`,
  chk_faint_panel: (p: { ratio: string | number; floor: string | number }) => `Faint text on the panel reads ${p.ratio} : 1, below the floor of ${p.floor} : 1. Make the faint text lighter or the panel darker.`,
  chk_faint_sheet: (p: { ratio: string | number; floor: string | number }) => `Faint text on the sheet reads ${p.ratio} : 1, below the floor of ${p.floor} : 1. Make the faint text lighter or the sheet darker.`,
  clip_gone: 'CLIP NOT IN THE BANK',
  clip_label: (p: { n: string | number }) => `CLIP ${p.n}`,
  confirm_links: (p: { count: number }) => plural(p.count, {
    one: `${p.count} other account uses this theme. Your change reaches it.`,
    other: `${p.count} other accounts use this theme. Your change reaches them.`,
  }),
  confirm_save: 'SAVE FOR ALL',
  contrast_bad: (p: { pair: string | number; ratio: string | number; floor: string | number }) => `${p.pair} ${p.ratio} : 1 · BELOW ${p.floor} : 1 · THE SAVE IS REFUSED`,
  contrast_ok: (p: { pair: string | number; ratio: string | number; floor: string | number }) => `${p.pair} ${p.ratio} : 1 · CLEARS ${p.floor} : 1`,
  copy_code: 'COPY CODE',
  discard: 'DISCARD',
  err_activate: (p: { message: string | number }) => `The theme is saved, but it did not become active: ${p.message}`,
  err_entitlement: 'Making custom themes is not in the plan of this account.',
  err_failed: (p: { message: string | number }) => `The save failed: ${p.message}`,
  err_impersonation: 'An operator session cannot save a theme.',
  err_invalid: (p: { field: string | number; reason: string | number }) => `The server refused ${p.field}: ${p.reason}.`,
  err_no_meta: (p: { message: string | number }) => `The account server did not answer: ${p.message}`,
  err_signed_out: 'The session ended. Sign in on the hub, then save again.',
  err_too_large: (p: { max: string | number }) => `The theme is larger than ${p.max} bytes. Remove clips or tracks, then save again.`,
  field_anchoring: 'ANCHORING',
  field_aura: 'SHIELD AURA',
  field_banner: 'SEASON BANNER',
  field_beam: 'HEAL BEAM',
  field_cache_work: 'CACHES',
  field_currents: 'CURRENTS',
  field_currents_heat: 'CURRENTS HEAT MAP',
  field_damage: 'DAMAGE FIGURES',
  field_deployable: 'DEPLOYABLE ICON',
  field_deployable_collect: 'DEPLOYABLE COLLECT',
  field_deployable_lay: 'DEPLOYABLE LAY',
  field_deposit: 'DEPOSIT ICON',
  field_depth: 'DEPTH',
  field_depth_light: 'DEPTH ON PAPER',
  field_detonation: 'DETONATION',
  field_digits: 'GROUP DIGITS',
  field_dock: 'CHROME DOCK-IN',
  field_faction_edge: 'BORDER DASH',
  field_faction_edge_light: 'BORDER DASH ON PAPER',
  field_faction_hull: 'HULL PIP',
  field_faction_key: 'FACTION KEY',
  field_faction_site: 'HOLD CHARGE',
  field_gather: 'HARVESTING',
  field_hit_hull: 'HULL HITS',
  field_hit_shield: 'SHIELD HITS',
  field_hit_sink: 'FINAL BLOW',
  field_hold: 'HOLD SYMBOL',
  field_hold_fire: 'GUNS TIGHT',
  field_map_marker: 'MAP MARKER',
  field_notices: 'NOTICES',
  field_own_fleet: 'OWN FLEET MARK',
  field_own_hold: 'OWN HOLD MARK',
  field_poi: 'POINT OF INTEREST',
  field_reload: 'TUBE RELOAD',
  field_sea_mine: 'SEA MINE ICON',
  field_sea_mine_collect: 'SEA MINE COLLECT',
  field_sea_mine_detonation: 'SEA MINE DETONATION',
  field_sea_mine_lay: 'SEA MINE LAY',
  field_shield: 'SHIELD BAR',
  field_ship: 'SHIP ICON',
  field_shot_artillery: 'ARTILLERY SHOTS',
  field_shot_melee: 'CLOSE-IN SHOTS',
  field_shot_sentinel: 'TOWER SHOTS',
  field_spawn: 'SPAWN ANIMATION',
  field_squad_fleet: 'SQUAD FLEET MARK',
  field_squad_hold: 'SQUAD HOLD MARK',
  field_structure: 'STRUCTURE ICON',
  field_terrain: 'TERRAIN',
  field_territory: 'TERRITORY',
  field_torpedo: 'TORPEDO LOOK',
  fields_lede: 'Press a row to show it in the preview. A row with one look has a stepper that does not move.',
  gate_list_failed: 'YOUR THEMES DID NOT LOAD',
  gate_no_maker: 'A PREMIUM ACCOUNT MAKES CUSTOM THEMES',
  gate_no_maker_why: 'Making custom themes is not in the plan of this account. Every account with a Supporter plan uses a custom theme: type its code in THEMES of the MODDING section in the menu.',
  gate_no_meta: 'THE ACCOUNT SERVER DID NOT ANSWER',
  gate_premium_makes: 'A Premium plan makes one custom theme in each of the six theme categories: the colours of the interface, the music, the sound effects, the world looks, the map marks and the chart pieces. Players of your clan then use your themes through your code.',
  gate_see_plans: 'SEE THE PLANS',
  gate_signed_out: 'SIGN IN FIRST',
  gate_signed_out_why: 'The theme workshop needs an account. Sign in on the hub, then open the workshop again.',
  group_combat: 'COMBAT',
  group_deployables: 'DEPLOYABLES',
  group_faction: 'FACTION',
  group_interface: 'INTERFACE',
  group_map: 'MAP',
  group_support: 'SUPPORT',
  header_code: (p: { code: string | number }) => `YOUR CODE ${p.code}`,
  hulls_closed: 'PER HULL ▸',
  hulls_count: (p: { count: string | number }) => `${p.count} OVERRIDDEN`,
  hulls_lede: 'A hull row overrides the ship icon set for that hull. FOLLOW takes the set.',
  hulls_none: 'ALL FOLLOW',
  hulls_open: 'PER HULL ▾',
  hulls_overview: 'OVERVIEW',
  impersonated: 'AN OPERATOR SESSION CANNOT SAVE A THEME. THE WORKSHOP SHOWS THE THEMES AND SAVES NOTHING.',
  keep_mine: 'KEEP MINE',
  keep_range: 'KEEP COLOURS IN THE SUGGESTED RANGE',
  light_head: 'LIGHT IDENTITY: COMPUTED FROM YOUR COLOURS',
  light_value: (p: { label: string | number; value: string | number }) => `${p.label} in the light identity: ${p.value}`,
  make_active: 'MAKE THEME ACTIVE',
  meta_none: 'NO THEME YET · THIS TAB STARTS FROM AUTO',
  meta_only_you: 'ONLY YOU USE THIS THEME',
  meta_others: (p: { count: number }) => plural(p.count, {
    one: `${p.count} OTHER ACCOUNT USES THIS THEME`,
    other: `${p.count} OTHER ACCOUNTS USE THIS THEME`,
  }),
  meta_theme: (p: { code: string | number; version: string | number }) => `CODE ${p.code} · VERSION ${p.version}`,
  meta_unused: 'NO ACCOUNT USES THIS THEME',
  move_down: 'MOVE DOWN',
  move_up: 'MOVE UP',
  moved: (p: { hex: string | number }) => `Moved to ${p.hex} to stay in range.`,
  music_empty: 'The list is empty. Add at least one track from the bank below.',
  music_lede: 'A Music theme is a list of tracks from the audio bank, in play order. Add tracks, move them and press ▶ to hear one.',
  music_list: (p: { count: string | number; max: string | number }) => `YOUR LIST · ${p.count} / ${p.max}`,
  no_bank: 'THIS HOST PUBLISHES NO AUDIO BANK',
  no_bank_why: 'The Music and the SFX tabs need the audio manifest of the host.',
  off: 'OFF',
  on: 'ON',
  open_hub: 'OPEN THE HUB',
  order_warn: (p: { lower: string | number; upper: string | number }) => `${p.lower} IS LIGHTER THAN ${p.upper}`,
  pair_faint_panel: 'FAINT TEXT ON PANEL',
  pair_faint_sheet: 'FAINT TEXT ON SHEET',
  pair_text_panel: 'TEXT ON PANEL',
  pick_label: (p: { row: string | number }) => `Pick the ${p.row} look`,
  preview_dark: 'DARK',
  preview_identity: 'PREVIEW',
  preview_identity_label: 'The identity of the preview',
  preview_light: 'LIGHT',
  preview_map_note: 'The map keeps the identity of the page. The identity of the page is a choice of OPTIONS.',
  reading_historical: 'HISTORICAL',
  reading_modern: 'MODERN',
  reason_count: 'the list has too few or too many entries',
  reason_missing: 'it is missing',
  reason_not_object: 'it must be an object',
  reason_pattern: 'the text has the wrong shape',
  reason_range: 'the number is outside its bounds',
  reason_syntax: 'the body is not JSON',
  reason_type: 'it has the wrong type',
  reason_unknown: 'it is not in the theme contract',
  remove: 'REMOVE',
  replay: 'REPLAY',
  restored: 'Restored your unsaved edits of this tab.',
  revert: 'REVERT TAB',
  row_tracks: 'YOUR LIST',
  row_voice: 'VOICE TIMING',
  sample: 'PLAY A SAMPLE',
  save: 'SAVE',
  save_off: (p: { pair: string | number; floor: string | number }) => `${p.pair} IS BELOW ${p.floor} : 1`,
  saved: (p: { code: string | number; version: string | number }) => `SAVED · CODE ${p.code} · VERSION ${p.version} · NEXT: COPY THE CODE FOR YOUR CLAN`,
  saved_active: (p: { code: string | number; version: string | number }) => `SAVED · CODE ${p.code} · VERSION ${p.version} · ACTIVE · NEXT: COPY THE CODE FOR YOUR CLAN`,
  saving: 'SAVING…',
  sfx_clip_cap: (p: { count: string | number; max: string | number }) => `${p.count} / ${p.max} CLIPS`,
  sfx_effect: 'EFFECT',
  sfx_groups: ['CORE SET', 'CONTACTS AND COMBAT', 'ECONOMY', 'ORDERS', 'TERRITORY AND SEASON', 'CAPTAINS', 'CLAN, HONOUR AND THE CLOCK', 'ACHIEVEMENTS', 'ARCADE · LOBBY AND COUNTDOWN', 'ARCADE · MATCH', 'CASINO', 'MENU'],
  sfx_lede: 'Pick the clips of each cue. A cue with no clip is silent in this theme. The game mutes some cues, and this tab does not show them.',
  sfx_no_clips: 'The bank holds no clip for this cue.',
  sfx_summary: (p: { fx: string | number; voice: string | number }) => `${p.fx} FX · ${p.voice} VOICE`,
  sfx_timing: 'TIMING',
  sfx_voice: 'VOICE',
  share_line: (p: { code: string | number }) => `Players of your clan type ${p.code} in THEMES of the MODDING section in the menu to use this theme.`,
  shuffle: 'SHUFFLE',
  started_from: (p: { name: string | number }) => `Started from ${p.name}.`,
  step_next: (p: { row: string | number }) => `Next ${p.row} look`,
  step_pos: (p: { n: string | number; count: string | number }) => `${p.n}/${p.count}`,
  step_prev: (p: { row: string | number }) => `Previous ${p.row} look`,
  stop_sample: 'STOP THE SAMPLE',
  tab_chart: 'CHART',
  tab_marks: 'MARKS',
  tab_music: 'MUSIC',
  tab_sfx: 'SFX',
  tab_ui: 'UI',
  tab_unsaved: 'unsaved changes',
  tab_world: 'WORLD',
  tabs_label: 'Theme categories',
  timing_theme: 'THEME',
  title: 'THEME WORKSHOP',
  token_accent: 'ACCENT',
  token_deep: 'DEEP INK',
  token_faint: 'FAINT TEXT',
  token_ink: 'PAGE INK',
  token_panel: 'PANEL',
  token_sheet: 'SHEET',
  token_text: 'TEXT',
  track_gone: 'NOT IN THE AUDIO BANK',
  ui_start: 'START FROM',
  undo: 'UNDO',
  unsaved_leave: (p: { count: number }) => plural(p.count, {
    one: `${p.count} tab holds changes you did not save. Press ← HUB again to leave without them.`,
    other: `${p.count} tabs hold changes you did not save. Press ← HUB again to leave without them.`,
  }),
  unsaved_tab: (p: { tab: string | number }) => `The ${p.tab} tab holds changes you did not save. They stay on this page until you save them or leave the page.`,
  val_hsl: 'HSL',
  val_hsl_value: (p: { h: string | number; s: string | number; l: string | number }) => `${p.h}°  ${p.s} %  ${p.l} %`,
  val_oklch: 'OKLCh',
  val_oklch_value: (p: { l: string | number; c: string | number }) => `L ${p.l}  C ${p.c}`,
  val_out: 'OUTSIDE THE RANGE',
  val_range: 'RANGE',
  val_range_band: (p: { lmin: string | number; lmax: string | number; cmin: string | number; cmax: string | number }) => `L ${p.lmin}–${p.lmax} · C ${p.cmin}–${p.cmax}`,
  val_range_ceiling: (p: { lmin: string | number; lmax: string | number; cmax: string | number }) => `L ${p.lmin}–${p.lmax} · C ≤ ${p.cmax}`,
  val_span: (p: { h: string | number; lmin: string | number; lmax: string | number }) => `(at ${p.h}°: HSL L ${p.lmin}–${p.lmax} %)`,
  val_span_none: (p: { h: string | number }) => `(at ${p.h}°: no sRGB colour is in the range)`,
  values_closed: 'COLOUR VALUES ▸',
  values_lede: 'Each token has a suggested range in OKLCh lightness and chroma. The hue is free. The range never refuses a save.',
  values_open: 'COLOUR VALUES ▾',
  voice_after: 'VOICE AFTER THE EFFECT',
  voice_delay: 'VOICE DELAY · MS',
};

const workshopLabels_en: S.WorkshopLabels = {
  cue_achievement: 'ACHIEVEMENT',
  cue_ambush_shot: 'AMBUSH SHOT',
  cue_arcade_base_fire: 'YOUR BASE FIRES',
  cue_arcade_buy: 'SHIP OR ROUND BOUGHT',
  cue_arcade_capture_broken: 'CAPTURE BROKEN',
  cue_arcade_capture_start: 'CAPTURE STARTED',
  cue_arcade_capture_threat: 'STRUCTURE UNDER CAPTURE',
  cue_arcade_clock_tick: 'LAST TEN SECONDS',
  cue_arcade_count: 'COUNTDOWN 3 2 1',
  cue_arcade_draw: 'DRAW',
  cue_arcade_fight: 'FIGHT',
  cue_arcade_hold: 'HOLD STARTS',
  cue_arcade_hold_broken: 'HOLD BROKEN',
  cue_arcade_kill: 'KILL CREDITED',
  cue_arcade_last_minute: 'LAST MINUTE',
  cue_arcade_lose: 'LOSS',
  cue_arcade_match_found: 'MATCH FOUND',
  cue_arcade_objective: 'WIN STEP',
  cue_arcade_queue_join: 'QUEUE JOINED',
  cue_arcade_queue_leave: 'QUEUE LEFT',
  cue_arcade_seat_loaded: 'SEAT LOADED',
  cue_arcade_sov_behind: 'ANOTHER TEAM TAKES THE LEAD',
  cue_arcade_sov_lead: 'YOUR TEAM TAKES THE LEAD',
  cue_arcade_spawn: 'AUTO SPAWN ARRIVES',
  cue_arcade_step_reset: 'STEP RESET',
  cue_arcade_surrender: 'SEAT SURRENDERED',
  cue_arcade_verdict: 'VERDICT FOR A SPECTATOR',
  cue_arcade_win: 'WIN',
  cue_auction_sold: 'MARKET SALE',
  cue_beacon_anchor: 'BEACON ANCHORS',
  cue_beacon_destroyed: 'BEACON DESTROYED',
  cue_beacon_hostile: 'HOSTILE BEACON ANCHORS',
  cue_beacon_pulse: 'BEACON PULSE',
  cue_blueprint_acquired: 'BLUEPRINT ACQUIRED',
  cue_blueprint_masterwork: 'MASTERWORK BLUEPRINT',
  cue_build_queued: 'BUILD QUEUED',
  cue_captain_lost: 'CAPTAIN CAPTURED',
  cue_captain_promoted: 'CAPTAIN PROMOTED',
  cue_captain_recruited: 'CAPTAIN RECRUITED',
  cue_captain_taken: 'ENEMY CAPTAIN TAKEN',
  cue_cargo_delivered: 'CARGO LANDED',
  cue_casino_ball: 'BALL DROPS',
  cue_casino_chip: 'STAKE PLACED',
  cue_casino_deal: 'CARD DEALT',
  cue_casino_jackpot: 'JACKPOT',
  cue_casino_lose: 'STAKE LOST',
  cue_casino_payout: 'BIG PAYOUT',
  cue_casino_reel_stop: 'REEL STOPS',
  cue_casino_seat: 'SEAT TAKEN',
  cue_casino_wheel: 'WHEEL TURNS',
  cue_casino_win: 'TABLE PAYS',
  cue_casino_your_turn: 'YOUR TURN',
  cue_cataclysm: 'NEW SEASON OPENS',
  cue_clan_hail: 'CLAN APPLICATION',
  cue_club_payout: 'CLUB SHARE PAID',
  cue_contact_broken: 'CONTACT BROKEN',
  cue_contact_lost: 'CONTACT LOST',
  cue_contact_new: 'NEW CONTACT',
  cue_course_plotted: 'COURSE PLOTTED',
  cue_day_night: 'DAY AND NIGHT',
  cue_deposit_depleted: 'DEPOSIT WORKED OUT',
  cue_enemy_destroyed: 'ENEMY DESTROYED',
  cue_expedition_departed: 'EXPEDITION DEPARTS',
  cue_expedition_returned: 'EXPEDITION RETURNS',
  cue_fleet_departs: 'FLEET DEPARTS',
  cue_fleet_fatigued: 'FLEET FATIGUED',
  cue_fleet_fight: 'YOUR GUNS HIT FIRST',
  cue_fleet_hit: 'LATER GUN HITS',
  cue_fleet_returned: 'FLEET DOCKS',
  cue_fleet_sink: 'FLEET SINKS',
  cue_guard_kill: 'GUARD KILLS A ROUND',
  cue_honour_awarded: 'HONOUR AWARDED',
  cue_hull_repaired: 'HULL REPAIRED',
  cue_insufficient_resources: 'NOT ENOUGH RESOURCES',
  cue_magazine_empty: 'MAGAZINE EMPTY',
  cue_map_arrival: 'MAP ARRIVAL',
  cue_menu_back: 'SHEET CLOSES',
  cue_menu_badge: 'AWARD OR UNLOCK',
  cue_menu_chat_recv: 'CHAT LINE ARRIVES',
  cue_menu_chat_send: 'CHAT LINE SENT',
  cue_menu_error: 'ACTION REFUSED',
  cue_menu_launch: 'YOU ENTER A WORLD',
  cue_menu_press: 'BUTTON PRESS',
  cue_menu_purchase: 'SHOP ORDER CONFIRMED',
  cue_menu_rename: 'RENAME ACCEPTED',
  cue_menu_signin: 'SIGN-IN',
  cue_menu_tab: 'TAB OR PAGE CHANGES',
  cue_menu_tick: 'STEPPER STEP',
  cue_menu_toggle: 'SWITCH CHANGES',
  cue_object_held: 'STRATEGIC OBJECT HELD',
  cue_object_lost: 'STRATEGIC OBJECT LOST',
  cue_order_ack: 'LINK UP',
  cue_order_refused: 'ORDER REFUSED',
  cue_quake_final: 'SCORES FINAL',
  cue_quake_settle: 'SEAQUAKE · SETTLEMENT',
  cue_quake_stage1: 'SEAQUAKE · FLOOR SHIFT',
  cue_quake_stage2: 'SEAQUAKE · WAR ECONOMY',
  cue_queue_complete: 'QUEUE JOB DONE',
  cue_redraft_done: 'REDRAFT COMPLETE',
  cue_reload_complete: 'RELOAD COMPLETE',
  cue_requirement_missing: 'REQUIREMENT MISSING',
  cue_research_complete: 'RESEARCH DONE',
  cue_round_select: 'ROUND SELECTED',
  cue_scan: 'FLEET SCAN',
  cue_sentinel_anchor: 'SENTINEL ANCHORS',
  cue_shields_down: 'SHIELDS DOWN',
  cue_ship_launched: 'SHIP READY',
  cue_siege_attack: 'SIEGE · ATTACK',
  cue_siege_defend: 'SIEGE · DEFEND',
  cue_siege_failed: 'SIEGE FAILED',
  cue_signature_order: 'SIGNATURE ORDER SPENT',
  cue_signature_ready: 'SIGNATURE ORDER READY',
  cue_sonar_sweep: 'BASE SONAR PING',
  cue_sov1_taken: 'A CELL FLIPS',
  cue_sov2_taken: 'A SITE IS CAPTURED',
  cue_squad_ping: 'SQUAD SIGNAL',
  cue_taking_damage: 'FIRST HIT TAKEN',
  cue_tech_unlocked: 'TECH UNLOCKED',
  cue_tender_anchor: 'TENDER ANCHORS',
  cue_territory_lost: 'TERRITORY LOST',
  cue_torpedo_explode: 'TORPEDO GOES OFF',
  cue_torpedo_fire: 'TORPEDO FIRED',
  cue_torpedo_incoming: 'TORPEDO INCOMING',
  cue_torpedo_repair: 'REPAIR ROUND',
  cue_torpor_burst: 'ROUND BURST',
  cue_trial_passed: 'TRIAL PASSED',
  cue_truce_ended: 'TRUCE ENDS',
  cue_truce_tick: 'TRUCE COUNTDOWN',
  cue_under_attack: 'UNDER ATTACK',
  cue_we_are_detected: 'WE ARE DETECTED',
  piece_banks: 'BANKS',
  piece_battle_marks: 'BATTLE MARKS',
  piece_bearing_lines: 'LINES OF BEARING',
  piece_border_band: 'BORDER BAND',
  piece_bottom_nature: 'SEABED LETTERS',
  piece_cables: 'CABLES',
  piece_cardinal_marks: 'GUT MARKS',
  piece_cartouche: 'CARTOUCHE',
  piece_clan_burgee: 'CLAN BURGEE',
  piece_coastal_profile: 'COASTAL PROFILE',
  piece_compass_rose: 'COMPASS ROSE',
  piece_current_arrows: 'CURRENTS',
  piece_depth_tints: 'DEPTH TINTS',
  piece_designations: 'SONAR DESIGNATIONS',
  piece_edge_seam: 'EDGE SEAM',
  piece_epicentre: 'EPICENTRE',
  piece_faction_key: 'FACTION KEY',
  piece_fairways: 'FAIRWAYS',
  piece_graticule: 'GRATICULE',
  piece_harbour_limits: 'HARBOUR LIMITS',
  piece_hazards: 'HAZARDS',
  piece_heraldry: 'HERALDRY',
  piece_here_be_monsters: 'HERE BE MONSTERS',
  piece_hold_site: 'OLD HOLD SITE',
  piece_imprint: 'IMPRINT',
  piece_inbox_pins: 'INBOX PINS',
  piece_isobaths: 'DEPTH LINES',
  piece_legend: 'LEGEND',
  piece_light_chars: 'LIGHT CHARACTERISTICS',
  piece_limit_line: 'LIMIT LINES',
  piece_listening_watch: 'LISTENING WATCH',
  piece_map_markers: 'MAP MARKERS',
  piece_margin_warning: 'MARGIN WARNING',
  piece_memorial_reef: 'MEMORIAL REEF',
  piece_neat_line: 'NEAT LINE',
  piece_picket_line: 'PICKET LINE',
  piece_place_names: 'PLACE NAMES',
  piece_points_of_interest: 'POINTS OF INTEREST',
  piece_pool_monument: 'HALL OF FAME MONUMENT',
  piece_range_rings: 'RANGE RINGS',
  piece_restricted: 'RESTRICTED AREAS',
  piece_ribbons: 'RIBBON BANNERS',
  piece_ship_tracks: 'SHIP TRACKS',
  piece_shipping_lanes: 'SHIPPING LANES',
  piece_shoal_stipple: 'SHOAL STIPPLE',
  piece_sonar_sweep: 'SONAR SWEEP',
  piece_soundings: 'SOUNDINGS',
  piece_speed_label: 'SPEED LABEL',
  piece_spoil_ground: 'SPOIL GROUND',
  piece_tidal_diamond: 'TIDAL DIAMOND',
  piece_torpedo_run: 'TORPEDO RUN',
  piece_water_lines: 'WATER LINES',
  piece_works: 'WORKS IN PROGRESS',
  piece_wrecks: 'WRECKS',
};

const world_en: S.World = {
  house_name: (p: { name: string | number }) => `House ${p.name}`,
  unclaimed: 'Unclaimed',
};

export const tables = {
  overlay: overlay_en,
  photo: photo_en,
  quickchat: quickchat_en,
  relayMark: relayMark_en,
  replay: replay_en,
  replayPage: replayPage_en,
  reportSheet: reportSheet_en,
  seamarks: seamarks_en,
  seamountName: seamountName_en,
  seasonSummary: seasonSummary_en,
  settlement: settlement_en,
  share: share_en,
  siege: siege_en,
  sonarlab: sonarlab_en,
  squad: squad_en,
  state: state_en,
  symbols: symbols_en,
  terrainlab: terrainlab_en,
  timelapse: timelapse_en,
  touchLog: touchLog_en,
  trials: trials_en,
  viewpanel: viewpanel_en,
  warcharts: warcharts_en,
  welcome: welcome_en,
  workshop: workshop_en,
  workshopLabels: workshopLabels_en,
  world: world_en,
} satisfies Partial<S.StringTables>;
